// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: var(--font-sans), ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
:root {
  --radius: 0.65rem;
  --background: oklch(1 0 0deg);
  --foreground: oklch(0.145 0 0deg);
  --hajj-primary: hsl(145deg 45% 35%);
  --hajj-primary-foreground: hsl(0deg 0% 98%);
  --hajj-secondary: hsl(145deg 35% 50%);
  --hajj-accent: hsl(85deg 65% 60%);
  --hajj-muted: hsl(145deg 10% 85%);
  --card: oklch(1 0 0deg);
  --card-foreground: oklch(0.145 0 0deg);
  --popover: hsl(0deg 0% 100%);
  --popover-foreground: hsl(222.2deg 47.4% 11.2%);
  --primary: oklch(0.205 0 0deg);
  --primary-foreground: oklch(0.985 0 0deg);
  --secondary: oklch(0.97 0 0deg);
  --secondary-foreground: oklch(0.205 0 0deg);
  --muted: oklch(0.97 0 0deg);
  --muted-foreground: oklch(0.556 0 0deg);
  --accent: hsl(210deg 40% 96.1%);
  --accent-foreground: oklch(0.205 0 0deg);
  --destructive: hsl(0deg 100% 50%);
  --destructive-foreground: hsl(210deg 40% 98%);
  --border: oklch(1 0deg 0deg / 10%);
  --input: hsl(216deg 34% 17%);
  --chart-1: oklch(0.646 0.222 41.116deg);
  --chart-5: oklch(0.769 0.188 70.08deg);
  --sidebar: oklch(0.985 0 0deg);
  --sidebar-foreground: oklch(0.145 0 0deg);
  --sidebar-primary: oklch(0.488 0.243 264.376deg);
  --sidebar-primary-foreground: oklch(0.985 0 0deg);
  --sidebar-accent: oklch(0.269 0 0deg);
  --sidebar-accent-foreground: oklch(0.985 0 0deg);
  --sidebar-border: oklch(1 0 0deg / 10%);
  --sidebar-ring: oklch(0.556 0 0deg);
  }

.dark {
  --background: oklch(0.145 0 0deg);
  --foreground: oklch(0.985 0 0deg);
  --card: oklch(0.205 0 0deg);
  --card-foreground: oklch(0.985 0 0deg);
  --popover: hsl(0deg 0% 100%);
  --popover-foreground: hsl(222.2deg 47.4% 11.2%);
  --primary: oklch(0.922 0 0deg);
  --primary-foreground: oklch(0.205 0 0deg);
  --secondary: oklch(0.269 0 0deg);
  --secondary-foreground: oklch(0.985 0 0deg);
  --muted: oklch(0.269 0 0deg);
  --muted-foreground: oklch(0.708 0 0deg);
  --accent: hsl(210deg 40% 96.1%);
  --accent-foreground: hsl(222.2deg 47.4% 11.2%);
  --destructive: hsl(0deg 63% 31%);
  --destructive-foreground: hsl(210deg 40% 98%);
  --border: oklch(1 0 0deg / 10%);
  --input: hsl(216deg 34% 17%);
  --ring: oklch(0.556 0 0deg);
  --chart-1: oklch(0.488 0.243 264.376deg);
  --chart-2: oklch(0.696 0.17 162.48deg);
  --chart-3: oklch(0.769 0.188 70.08deg);
  --chart-4: oklch(0.627 0.265 303.9deg);
  --chart-5: oklch(0.645 0.246 16.439deg);
  --sidebar: oklch(0.205 0 0deg);
  --sidebar-foreground: oklch(0.985 0 0deg);
  --sidebar-primary: oklch(0.488 0.243 264.376deg);
  --sidebar-primary-foreground: oklch(0.985 0 0deg);
  --sidebar-accent: oklch(0.269 0 0deg);
  --sidebar-accent-foreground: oklch(0.985 0 0deg);
  --sidebar-border: oklch(1 0 0deg / 10%);
  --sidebar-ring: oklch(0.556 0 0deg);
}
  body {
  background-color: var(--background);
  color: var(--foreground);

    font-family: sans-serif;
}
.\\!container {
  width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 1400px) {

  .\\!container {
    max-width: 1400px !important;
  }

  .container {
    max-width: 1400px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-left-\\[4\\.55\\%\\] {
  left: -4.55%;
}
.-top-\\[100px\\] {
  top: -100px;
}
.-top-\\[8\\.13cqw\\] {
  top: -8.13cqw;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.left-0 {
  left: 0px;
}
.left-10 {
  left: 2.5rem;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-3 {
  left: 0.75rem;
}
.left-5 {
  left: 1.25rem;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\.5 {
  right: 0.375rem;
}
.right-10 {
  right: 2.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-6 {
  right: 1.5rem;
}
.right-8 {
  right: 2rem;
}
.top-0 {
  top: 0px;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-20 {
  top: 5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-\\[18px\\] {
  top: 18px;
}
.top-\\[19px\\] {
  top: 19px;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[60px\\] {
  top: 60px;
}
.top-full {
  top: 100%;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-auto {
  z-index: auto;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.order-4 {
  order: 4;
}
.order-last {
  order: 9999;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-full {
  grid-column: 1 / -1;
}
.col-start-2 {
  grid-column-start: 2;
}
.row-span-2 {
  grid-row: span 2 / span 2;
}
.row-start-1 {
  grid-row-start: 1;
}
.row-start-2 {
  grid-row-start: 2;
}
.\\!m-0 {
  margin: 0px !important;
}
.m-0 {
  margin: 0px;
}
.m-2\\.5 {
  margin: 0.625rem;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3\\.5 {
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mx-px {
  margin-left: 1px;
  margin-right: 1px;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2\\.5 {
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.\\!mt-1 {
  margin-top: 0.25rem !important;
}
.\\!mt-3 {
  margin-top: 0.75rem !important;
}
.-mb-1 {
  margin-bottom: -0.25rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-3\\.5 {
  margin-bottom: 0.875rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[18px\\] {
  margin-bottom: 18px;
}
.mb-\\[21px\\] {
  margin-bottom: 21px;
}
.mb-\\[22px\\] {
  margin-bottom: 22px;
}
.mb-\\[25px\\] {
  margin-bottom: 25px;
}
.mb-\\[26px\\] {
  margin-bottom: 26px;
}
.mb-\\[35px\\] {
  margin-bottom: 35px;
}
.mb-\\[3px\\] {
  margin-bottom: 3px;
}
.mb-\\[5px\\] {
  margin-bottom: 5px;
}
.mb-\\[7px\\] {
  margin-bottom: 7px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-\\[13px\\] {
  margin-top: 13px;
}
.mt-\\[18px\\] {
  margin-top: 18px;
}
.mt-\\[19px\\] {
  margin-top: 19px;
}
.mt-\\[23px\\] {
  margin-top: 23px;
}
.mt-\\[25px\\] {
  margin-top: 25px;
}
.mt-\\[34px\\] {
  margin-top: 34px;
}
.mt-\\[3px\\] {
  margin-top: 3px;
}
.mt-\\[42px\\] {
  margin-top: 42px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-\\[7px\\] {
  margin-top: 7px;
}
.mt-auto {
  margin-top: auto;
}
.mt-px {
  margin-top: 1px;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.\\!flex {
  display: flex !important;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.\\!table {
  display: table !important;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.size-1\\.5 {
  width: 0.375rem;
  height: 0.375rem;
}
.size-10 {
  width: 2.5rem;
  height: 2.5rem;
}
.size-11 {
  width: 2.75rem;
  height: 2.75rem;
}
.size-2 {
  width: 0.5rem;
  height: 0.5rem;
}
.size-3 {
  width: 0.75rem;
  height: 0.75rem;
}
.size-3\\.5 {
  width: 0.875rem;
  height: 0.875rem;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.size-5 {
  width: 1.25rem;
  height: 1.25rem;
}
.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
.size-7 {
  width: 1.75rem;
  height: 1.75rem;
}
.size-8 {
  width: 2rem;
  height: 2rem;
}
.size-9 {
  width: 2.25rem;
  height: 2.25rem;
}
.size-\\[--cell-size\\] {
  width: var(--cell-size);
  height: var(--cell-size);
}
.size-\\[13px\\] {
  width: 13px;
  height: 13px;
}
.size-\\[14px\\] {
  width: 14px;
  height: 14px;
}
.size-\\[15px\\] {
  width: 15px;
  height: 15px;
}
.size-\\[16px\\] {
  width: 16px;
  height: 16px;
}
.size-\\[17px\\] {
  width: 17px;
  height: 17px;
}
.size-\\[188px\\] {
  width: 188px;
  height: 188px;
}
.size-\\[18px\\] {
  width: 18px;
  height: 18px;
}
.size-\\[216px\\] {
  width: 216px;
  height: 216px;
}
.size-\\[22px\\] {
  width: 22px;
  height: 22px;
}
.size-\\[30px\\] {
  width: 30px;
  height: 30px;
}
.size-\\[46px\\] {
  width: 46px;
  height: 46px;
}
.size-\\[50px\\] {
  width: 50px;
  height: 50px;
}
.size-\\[9px\\] {
  width: 9px;
  height: 9px;
}
.\\!h-8 {
  height: 2rem !important;
}
.\\!h-auto {
  height: auto !important;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-28 {
  height: 7rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[--cell-size\\] {
  height: var(--cell-size);
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[112px\\] {
  height: 112px;
}
.h-\\[13px\\] {
  height: 13px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[17px\\] {
  height: 17px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[206px\\] {
  height: 206px;
}
.h-\\[21px\\] {
  height: 21px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[230px\\] {
  height: 230px;
}
.h-\\[255px\\] {
  height: 255px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[31px\\] {
  height: 31px;
}
.h-\\[340px\\] {
  height: 340px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[35px\\] {
  height: 35px;
}
.h-\\[37px\\] {
  height: 37px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[39px\\] {
  height: 39px;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[46px\\] {
  height: 46px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[52px\\] {
  height: 52px;
}
.h-\\[58px\\] {
  height: 58px;
}
.h-\\[65px\\] {
  height: 65px;
}
.h-\\[68px\\] {
  height: 68px;
}
.h-\\[75px\\] {
  height: 75px;
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
  height: var(--radix-select-trigger-height);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.h-svh {
  height: 100svh;
}
.\\!max-h-\\[calc\\(100dvh_-_40px\\)\\] {
  max-height: calc(100dvh - 40px) !important;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-\\[--radix-select-content-available-height\\] {
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[246px\\] {
  max-height: 246px;
}
.max-h-\\[255px\\] {
  max-height: 255px;
}
.max-h-\\[308px\\] {
  max-height: 308px;
}
.max-h-\\[310px\\] {
  max-height: 310px;
}
.max-h-\\[42px\\] {
  max-height: 42px;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[calc\\(100dvh-1\\.5rem\\)\\] {
  max-height: calc(100dvh - 1.5rem);
}
.max-h-\\[calc\\(100dvh-1rem\\)\\] {
  max-height: calc(100dvh - 1rem);
}
.max-h-\\[calc\\(100dvh-3rem\\)\\] {
  max-height: calc(100dvh - 3rem);
}
.max-h-\\[calc\\(100dvh-48px\\)\\] {
  max-height: calc(100dvh - 48px);
}
.max-h-\\[calc\\(100dvh-4rem\\)\\] {
  max-height: calc(100dvh - 4rem);
}
.max-h-\\[min\\(420px\\2c calc\\(100dvh-110px\\)\\)\\] {
  max-height: min(420px,calc(100dvh - 110px));
}
.max-h-\\[min\\(596px\\2c calc\\(100vh-32px\\)\\)\\] {
  max-height: min(596px,calc(100vh - 32px));
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\] {
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.min-h-0 {
  min-height: 0px;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-12 {
  min-height: 3rem;
}
.min-h-16 {
  min-height: 4rem;
}
.min-h-24 {
  min-height: 6rem;
}
.min-h-6 {
  min-height: 1.5rem;
}
.min-h-7 {
  min-height: 1.75rem;
}
.min-h-8 {
  min-height: 2rem;
}
.min-h-9 {
  min-height: 2.25rem;
}
.min-h-\\[102px\\] {
  min-height: 102px;
}
.min-h-\\[116px\\] {
  min-height: 116px;
}
.min-h-\\[160px\\] {
  min-height: 160px;
}
.min-h-\\[232px\\] {
  min-height: 232px;
}
.min-h-\\[42px\\] {
  min-height: 42px;
}
.min-h-\\[480px\\] {
  min-height: 480px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[61px\\] {
  min-height: 61px;
}
.min-h-\\[62px\\] {
  min-height: 62px;
}
.min-h-\\[72px\\] {
  min-height: 72px;
}
.min-h-\\[76px\\] {
  min-height: 76px;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[82px\\] {
  min-height: 82px;
}
.min-h-\\[calc\\(100dvh-75px\\)\\] {
  min-height: calc(100dvh - 75px);
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-8 {
  width: 2rem !important;
}
.\\!w-\\[368px\\] {
  width: 368px !important;
}
.\\!w-\\[calc\\(100\\%_-_20px\\)\\] {
  width: calc(100% - 20px) !important;
}
.\\!w-\\[calc\\(100\\%_-_24px\\)\\] {
  width: calc(100% - 24px) !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-0 {
  width: 0px;
}
.w-1 {
  width: 0.25rem;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/5 {
  width: 40%;
}
.w-28 {
  width: 7rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[--cell-size\\] {
  width: var(--cell-size);
}
.w-\\[--sidebar-width\\] {
  width: var(--sidebar-width);
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[104px\\] {
  width: 104px;
}
.w-\\[109\\.1\\%\\] {
  width: 109.1%;
}
.w-\\[11\\%\\] {
  width: 11%;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[12\\%\\] {
  width: 12%;
}
.w-\\[13\\%\\] {
  width: 13%;
}
.w-\\[135px\\] {
  width: 135px;
}
.w-\\[13px\\] {
  width: 13px;
}
.w-\\[145px\\] {
  width: 145px;
}
.w-\\[15px\\] {
  width: 15px;
}
.w-\\[160px\\] {
  width: 160px;
}
.w-\\[164px\\] {
  width: 164px;
}
.w-\\[170px\\] {
  width: 170px;
}
.w-\\[17px\\] {
  width: 17px;
}
.w-\\[18\\%\\] {
  width: 18%;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[182px\\] {
  width: 182px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[23\\%\\] {
  width: 23%;
}
.w-\\[244px\\] {
  width: 244px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[26\\%\\] {
  width: 26%;
}
.w-\\[27\\%\\] {
  width: 27%;
}
.w-\\[278px\\] {
  width: 278px;
}
.w-\\[298px\\] {
  width: 298px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[36px\\] {
  width: 36px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[42px\\] {
  width: 42px;
}
.w-\\[43\\%\\] {
  width: 43%;
}
.w-\\[460px\\] {
  width: 460px;
}
.w-\\[46px\\] {
  width: 46px;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[53\\%\\] {
  width: 53%;
}
.w-\\[570px\\] {
  width: 570px;
}
.w-\\[6\\%\\] {
  width: 6%;
}
.w-\\[640px\\] {
  width: 640px;
}
.w-\\[7\\%\\] {
  width: 7%;
}
.w-\\[72px\\] {
  width: 72px;
}
.w-\\[75px\\] {
  width: 75px;
}
.w-\\[8\\%\\] {
  width: 8%;
}
.w-\\[9\\%\\] {
  width: 9%;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[calc\\(100\\%-1\\.5rem\\)\\] {
  width: calc(100% - 1.5rem);
}
.w-\\[calc\\(100\\%-1rem\\)\\] {
  width: calc(100% - 1rem);
}
.w-\\[calc\\(100\\%-2rem\\)\\] {
  width: calc(100% - 2rem);
}
.w-\\[calc\\(100\\%-40px\\)\\] {
  width: calc(100% - 40px);
}
.w-\\[var\\(--radix-popover-trigger-width\\)\\] {
  width: var(--radix-popover-trigger-width);
}
.w-\\[var\\(--radix-select-trigger-width\\)\\] {
  width: var(--radix-select-trigger-width);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-11 {
  min-width: 2.75rem;
}
.min-w-5 {
  min-width: 1.25rem;
}
.min-w-9 {
  min-width: 2.25rem;
}
.min-w-\\[1050px\\] {
  min-width: 1050px;
}
.min-w-\\[1120px\\] {
  min-width: 1120px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[124px\\] {
  min-width: 124px;
}
.min-w-\\[1280px\\] {
  min-width: 1280px;
}
.min-w-\\[1420px\\] {
  min-width: 1420px;
}
.min-w-\\[19px\\] {
  min-width: 19px;
}
.min-w-\\[230px\\] {
  min-width: 230px;
}
.min-w-\\[650px\\] {
  min-width: 650px;
}
.min-w-\\[855px\\] {
  min-width: 855px;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[940px\\] {
  min-width: 940px;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
  min-width: var(--radix-select-trigger-width);
}
.\\!max-w-\\[640px\\] {
  max-width: 640px !important;
}
.max-w-0 {
  max-width: 0px;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-44 {
  max-width: 11rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-\\[--skeleton-width\\] {
  max-width: var(--skeleton-width);
}
.max-w-\\[1024px\\] {
  max-width: 1024px;
}
.max-w-\\[1100px\\] {
  max-width: 1100px;
}
.max-w-\\[1230px\\] {
  max-width: 1230px;
}
.max-w-\\[1248px\\] {
  max-width: 1248px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[145px\\] {
  max-width: 145px;
}
.max-w-\\[1460px\\] {
  max-width: 1460px;
}
.max-w-\\[1480px\\] {
  max-width: 1480px;
}
.max-w-\\[1520px\\] {
  max-width: 1520px;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[255px\\] {
  max-width: 255px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[290px\\] {
  max-width: 290px;
}
.max-w-\\[312px\\] {
  max-width: 312px;
}
.max-w-\\[365px\\] {
  max-width: 365px;
}
.max-w-\\[420px\\] {
  max-width: 420px;
}
.max-w-\\[448px\\] {
  max-width: 448px;
}
.max-w-\\[470px\\] {
  max-width: 470px;
}
.max-w-\\[480px\\] {
  max-width: 480px;
}
.max-w-\\[488px\\] {
  max-width: 488px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[512px\\] {
  max-width: 512px;
}
.max-w-\\[640px\\] {
  max-width: 640px;
}
.max-w-\\[660px\\] {
  max-width: 660px;
}
.max-w-\\[680px\\] {
  max-width: 680px;
}
.max-w-\\[720px\\] {
  max-width: 720px;
}
.max-w-\\[730px\\] {
  max-width: 730px;
}
.max-w-\\[736px\\] {
  max-width: 736px;
}
.max-w-\\[750px\\] {
  max-width: 750px;
}
.max-w-\\[780px\\] {
  max-width: 780px;
}
.max-w-\\[800px\\] {
  max-width: 800px;
}
.max-w-\\[820px\\] {
  max-width: 820px;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[940px\\] {
  max-width: 940px;
}
.max-w-\\[calc\\(\\(100\\%_-_42px\\)\\/2\\)\\] {
  max-width: calc((100% - 42px) / 2);
}
.max-w-\\[calc\\(100\\%-32px\\)\\] {
  max-width: calc(100% - 32px);
}
.max-w-\\[calc\\(100vw-24px\\)\\] {
  max-width: calc(100vw - 24px);
}
.max-w-\\[calc\\(100vw-2rem\\)\\] {
  max-width: calc(100vw - 2rem);
}
.max-w-\\[calc\\(100vw-32px\\)\\] {
  max-width: calc(100vw - 32px);
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-\\[0_1_395px\\] {
  flex: 0 1 395px;
}
.flex-\\[0_1_auto\\] {
  flex: 0 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.\\!shrink-0 {
  flex-shrink: 0 !important;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.basis-full {
  flex-basis: 100%;
}
.table-fixed {
  table-layout: fixed;
}
.caption-bottom {
  caption-side: bottom;
}
.border-collapse {
  border-collapse: collapse;
}
.border-separate {
  border-collapse: separate;
}
.border-spacing-0 {
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\] {
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\] {
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\] {
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\] {
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-px {
  --tw-translate-x: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-100\\%\\] {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-px {
  --tw-translate-x: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.2\\] {
  --tw-scale-x: 1.2;
  --tw-scale-y: 1.2;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.select-all {
  -webkit-user-select: all;
          user-select: all;
}
.resize-y {
  resize: vertical;
}
.list-inside {
  list-style-position: inside;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.auto-rows-fr {
  grid-auto-rows: minmax(0, 1fr);
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[100px_1fr_auto\\] {
  grid-template-columns: 100px 1fr auto;
}
.grid-cols-\\[1fr_1\\.2fr\\] {
  grid-template-columns: 1fr 1.2fr;
}
.grid-cols-\\[1fr_auto\\] {
  grid-template-columns: 1fr auto;
}
.grid-cols-\\[30px_minmax\\(0\\2c 1fr\\)_13px\\] {
  grid-template-columns: 30px minmax(0,1fr) 13px;
}
.grid-cols-\\[65px_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 65px minmax(0,1fr);
}
.grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: auto minmax(0,1fr);
}
.grid-cols-\\[minmax\\(0\\2c 0\\.85fr\\)_minmax\\(0\\2c 1\\.15fr\\)\\] {
  grid-template-columns: minmax(0,0.85fr) minmax(0,1.15fr);
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_14px\\] {
  grid-template-columns: minmax(0,1fr) 14px;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_18px\\] {
  grid-template-columns: minmax(0,1fr) 18px;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_2\\.25rem\\] {
  grid-template-columns: minmax(0,1fr) 2.25rem;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto\\] {
  grid-template-columns: minmax(0,1fr) auto;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.15fr\\)\\] {
  grid-template-columns: minmax(0,1fr) minmax(0,1.15fr);
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(100px\\2c 150px\\)\\] {
  grid-template-columns: minmax(0,1fr) minmax(100px,150px);
}
.grid-rows-\\[auto_minmax\\(0\\2c 1fr\\)_auto\\] {
  grid-template-rows: auto minmax(0,1fr) auto;
}
.\\!flex-row {
  flex-direction: row !important;
}
.flex-row {
  flex-direction: row;
}
.\\!flex-col {
  flex-direction: column !important;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.place-content-center {
  place-content: center;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.\\!items-center {
  align-items: center !important;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.\\!justify-between {
  justify-content: space-between !important;
}
.justify-between {
  justify-content: space-between;
}
.\\!gap-0 {
  gap: 0px !important;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-9 {
  gap: 2.25rem;
}
.gap-\\[15px\\] {
  gap: 15px;
}
.gap-\\[18px\\] {
  gap: 18px;
}
.gap-\\[23px\\] {
  gap: 23px;
}
.gap-\\[30px\\] {
  gap: 30px;
}
.gap-\\[5px\\] {
  gap: 5px;
}
.gap-\\[7px\\] {
  gap: 7px;
}
.gap-\\[9px\\] {
  gap: 9px;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-\\[18px\\] {
  column-gap: 18px;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-\\[18px\\] {
  row-gap: 18px;
}
.\\!space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse)) !important;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.space-y-\\[13px\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(13px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(13px * var(--tw-space-y-reverse));
}
.space-y-\\[5px\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(5px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(5px * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.divide-gray-300 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-stretch {
  align-self: stretch;
}
.overflow-auto {
  overflow: auto;
}
.\\!overflow-hidden {
  overflow: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.\\!overflow-visible {
  overflow: visible !important;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.text-balance {
  text-wrap: balance;
}
.text-pretty {
  text-wrap: pretty;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-\\[9px\\] {
  border-radius: 9px !important;
}
.\\!rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[11px\\] {
  border-radius: 11px;
}
.rounded-\\[13px\\] {
  border-radius: 13px;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[17px\\] {
  border-radius: 17px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[3px\\] {
  border-radius: 3px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-\\[9px\\] {
  border-radius: 9px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: var(--radius);
}
.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l-lg {
  border-top-left-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.rounded-l-md {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-md {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.rounded-t-sm {
  border-top-left-radius: calc(var(--radius) - 4px);
  border-top-right-radius: calc(var(--radius) - 4px);
}
.rounded-bl-lg {
  border-bottom-left-radius: var(--radius);
}
.rounded-br-lg {
  border-bottom-right-radius: var(--radius);
}
.rounded-tl-lg {
  border-top-left-radius: var(--radius);
}
.rounded-tr-lg {
  border-top-right-radius: var(--radius);
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.\\!border-t {
  border-top-width: 1px !important;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.\\!border-\\[\\#dbe4dd\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(219 228 221 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#e2e7e3\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(226 231 227 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#e5ebe7\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 235 231 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#287c50\\] {
  --tw-border-opacity: 1;
  border-color: rgb(40 124 80 / var(--tw-border-opacity, 1));
}
.border-\\[\\#7d8982\\] {
  --tw-border-opacity: 1;
  border-color: rgb(125 137 130 / var(--tw-border-opacity, 1));
}
.border-\\[\\#9cc5ab\\] {
  --tw-border-opacity: 1;
  border-color: rgb(156 197 171 / var(--tw-border-opacity, 1));
}
.border-\\[\\#9db5a6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(157 181 166 / var(--tw-border-opacity, 1));
}
.border-\\[\\#9fc5ff\\] {
  --tw-border-opacity: 1;
  border-color: rgb(159 197 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#a0b89d\\] {
  --tw-border-opacity: 1;
  border-color: rgb(160 184 157 / var(--tw-border-opacity, 1));
}
.border-\\[\\#a9c8b5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(169 200 181 / var(--tw-border-opacity, 1));
}
.border-\\[\\#b5e7bd\\] {
  --tw-border-opacity: 1;
  border-color: rgb(181 231 189 / var(--tw-border-opacity, 1));
}
.border-\\[\\#b7ccbe\\] {
  --tw-border-opacity: 1;
  border-color: rgb(183 204 190 / var(--tw-border-opacity, 1));
}
.border-\\[\\#b9d2c2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(185 210 194 / var(--tw-border-opacity, 1));
}
.border-\\[\\#c8dfd0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(200 223 208 / var(--tw-border-opacity, 1));
}
.border-\\[\\#c9dfd1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(201 223 209 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ccd6cf\\] {
  --tw-border-opacity: 1;
  border-color: rgb(204 214 207 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cdd7d0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(205 215 208 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cdd9d0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(205 217 208 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cfe0d5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(207 224 213 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d4dfd7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(212 223 215 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d4eae2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(212 234 226 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d5ded7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(213 222 215 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d5e0d9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(213 224 217 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d5e1d8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(213 225 216 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d6dfd8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(214 223 216 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d6dfd9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(214 223 217 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d6e0d9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(214 224 217 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d7ded9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(215 222 217 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d7dfda\\] {
  --tw-border-opacity: 1;
  border-color: rgb(215 223 218 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d7e3db\\] {
  --tw-border-opacity: 1;
  border-color: rgb(215 227 219 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d8e0db\\] {
  --tw-border-opacity: 1;
  border-color: rgb(216 224 219 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d8e1da\\] {
  --tw-border-opacity: 1;
  border-color: rgb(216 225 218 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d8e2db\\] {
  --tw-border-opacity: 1;
  border-color: rgb(216 226 219 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d9e2db\\] {
  --tw-border-opacity: 1;
  border-color: rgb(217 226 219 / var(--tw-border-opacity, 1));
}
.border-\\[\\#daebf2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(218 235 242 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dbe5de\\] {
  --tw-border-opacity: 1;
  border-color: rgb(219 229 222 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dbe7df\\] {
  --tw-border-opacity: 1;
  border-color: rgb(219 231 223 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dbe8fb\\] {
  --tw-border-opacity: 1;
  border-color: rgb(219 232 251 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dbe9df\\] {
  --tw-border-opacity: 1;
  border-color: rgb(219 233 223 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dce3db\\] {
  --tw-border-opacity: 1;
  border-color: rgb(220 227 219 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dce3de\\] {
  --tw-border-opacity: 1;
  border-color: rgb(220 227 222 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dce4df\\] {
  --tw-border-opacity: 1;
  border-color: rgb(220 228 223 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dce5df\\] {
  --tw-border-opacity: 1;
  border-color: rgb(220 229 223 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dde4df\\] {
  --tw-border-opacity: 1;
  border-color: rgb(221 228 223 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dde5e0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(221 229 224 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dee6e0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(222 230 224 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dfe5e1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(223 229 225 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dfe6e1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(223 230 225 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dfe6e2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(223 230 226 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dfe8e2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(223 232 226 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e0e6e2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(224 230 226 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e0e7e2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 226 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e0e7e3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 227 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e0e9e3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(224 233 227 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e1e7e2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(225 231 226 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e1e7e3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(225 231 227 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e2e7e4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 231 228 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e2e7e5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 231 229 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e3e6e4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(227 230 228 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e3e8e5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(227 232 229 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e3e8e6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(227 232 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e3e8e7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(227 232 231 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e3eae5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(227 234 229 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e3ebf6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(227 235 246 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e4e6df\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 230 223 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e4e9e5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 233 229 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e4eae5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 234 229 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e5e9e6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 233 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e5ebe6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 235 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e5ebe7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 235 231 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e6eae7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 234 231 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e6ebe7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 235 231 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e7ece8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(231 236 232 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e8ebe4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(232 235 228 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e8ece9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(232 236 233 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e8ede9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(232 237 233 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e8edea\\] {
  --tw-border-opacity: 1;
  border-color: rgb(232 237 234 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e9dff2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(233 223 242 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e9edea\\] {
  --tw-border-opacity: 1;
  border-color: rgb(233 237 234 / var(--tw-border-opacity, 1));
}
.border-\\[\\#edf0ec\\] {
  --tw-border-opacity: 1;
  border-color: rgb(237 240 236 / var(--tw-border-opacity, 1));
}
.border-\\[\\#edf0ee\\] {
  --tw-border-opacity: 1;
  border-color: rgb(237 240 238 / var(--tw-border-opacity, 1));
}
.border-\\[\\#edf1ee\\] {
  --tw-border-opacity: 1;
  border-color: rgb(237 241 238 / var(--tw-border-opacity, 1));
}
.border-\\[\\#f0e4c8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(240 228 200 / var(--tw-border-opacity, 1));
}
.border-\\[\\#f0f2f1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(240 242 241 / var(--tw-border-opacity, 1));
}
.border-\\[\\#f1ccd3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(241 204 211 / var(--tw-border-opacity, 1));
}
.border-\\[\\#f3dde4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(243 221 228 / var(--tw-border-opacity, 1));
}
.border-\\[--color-border\\] {
  border-color: var(--color-border);
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-border {
  border-color: var(--border);
}
.border-card {
  border-color: var(--card);
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/60 {
  border-color: rgb(229 231 235 / 0.6);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-hajj-primary {
  border-color: var(--hajj-primary);
}
.border-input {
  border-color: var(--input);
}
.border-muted {
  border-color: var(--muted);
}
.border-primary {
  border-color: var(--primary);
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-sidebar-border {
  border-color: var(--sidebar-border);
}
.border-transparent {
  border-color: transparent;
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.\\!bg-\\[\\#14231b75\\] {
  background-color: #14231b75 !important;
}
.\\!bg-\\[\\#28764d\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(40 118 77 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#00472f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 71 47 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00543b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 84 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0c3116\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(12 49 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#13231c66\\] {
  background-color: #13231c66;
}
.bg-\\[\\#162420\\]\\/35 {
  background-color: rgb(22 36 32 / 0.35);
}
.bg-\\[\\#28764d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 118 77 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#287c50\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 124 80 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#30372d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(48 55 45 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6e8c79\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(110 140 121 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F59E0B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#a4d5ac\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(164 213 172 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#cde8d2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(205 232 210 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d1dcd5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(209 220 213 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e2f1e8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(226 241 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e5ede7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(229 237 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e6ece7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 236 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e7efea\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 239 234 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e7f2eb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 242 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8f4e8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 244 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8f4ed\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 244 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8f5ed\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 245 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e9eeeb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 238 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eaf0eb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 240 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eaf2ec\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 242 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eaf3ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 243 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eaf5ed\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 245 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eaf6ee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 246 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#edf2ef\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 242 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#edf4ef\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 244 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#edf5ef\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 245 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eef3f7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 243 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eef7f1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 247 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eff2f0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 242 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eff7f2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 247 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eff8fc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 248 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eff9f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 249 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0f5f1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 245 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0f5fc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 245 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0f6ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 246 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0f7f2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 247 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0f8eb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 248 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f1f8f4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 248 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f2f6f3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 246 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3f2e8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 242 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3f7e9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 247 233 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f8f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 248 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f9f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 249 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4faf6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 250 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4fbf6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 251 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f5f7f6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 247 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f5f9f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 249 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f8f6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f8f7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f8fa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f9f6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 249 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f9f7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 249 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6faf7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 250 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f7f2fb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 242 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f7f9f8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 249 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f7f9fa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 249 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8faf8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8faf9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8fbf9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 251 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f9fafb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafaf8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafbf9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 251 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafbfa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 251 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafbfc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 251 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafcfb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 252 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fbefeb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 239 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fcf0f0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 240 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fcfdfb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 253 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fcfdfc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 253 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff0f2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 240 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff1cf\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 207 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff1f3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff3f6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 243 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff8e8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 248 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[--color-bg\\] {
  background-color: var(--color-bg);
}
.bg-accent {
  background-color: var(--accent);
}
.bg-background {
  background-color: var(--background);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-border {
  background-color: var(--border);
}
.bg-card {
  background-color: var(--card);
}
.bg-destructive {
  background-color: var(--destructive);
}
.bg-emerald-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/70 {
  background-color: rgb(249 250 251 / 0.7);
}
.bg-gray-50\\/80 {
  background-color: rgb(249 250 251 / 0.8);
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-200\\/20 {
  background-color: rgb(187 247 208 / 0.2);
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-green-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
}
.bg-hajj-muted {
  background-color: var(--hajj-muted);
}
.bg-hajj-primary {
  background-color: var(--hajj-primary);
}
.bg-hajj-primary-foreground {
  background-color: var(--hajj-primary-foreground);
}
.bg-input {
  background-color: var(--input);
}
.bg-muted {
  background-color: var(--muted);
}
.bg-popover {
  background-color: var(--popover);
}
.bg-primary {
  background-color: var(--primary);
}
.bg-red-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}
.bg-secondary {
  background-color: var(--secondary);
}
.bg-sidebar {
  background-color: var(--sidebar-background);
}
.bg-sidebar-border {
  background-color: var(--sidebar-border);
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-\\[linear-gradient\\(\\#10181147\\2c \\#1018117d_43\\%\\2c \\#1018115e_65\\%\\2c \\#1018111f\\)\\] {
  background-image: linear-gradient(#10181147,#1018117d 43%,#1018115e 65%,#1018111f);
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-none {
  background-image: none;
}
.from-amber-50 {
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-hajj-muted {
  --tw-gradient-from: var(--hajj-muted) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50 {
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-green-50 {
  --tw-gradient-to: #f0fdf4 var(--tw-gradient-to-position);
}
.to-orange-50\\/50 {
  --tw-gradient-to: rgb(255 247 237 / 0.5) var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.fill-current {
  fill: currentColor;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-\\[50\\%_54\\%\\] {
  object-position: 50% 54%;
}
.\\!p-0 {
  padding: 0px !important;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[10px\\] {
  padding: 10px;
}
.p-\\[15px\\] {
  padding: 15px;
}
.p-\\[25px\\] {
  padding: 25px;
}
.p-\\[30px\\] {
  padding: 30px;
}
.p-\\[50px\\] {
  padding: 50px;
}
.p-\\[5px\\] {
  padding: 5px;
}
.p-\\[7px\\] {
  padding: 7px;
}
.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[--cell-size\\] {
  padding-left: var(--cell-size);
  padding-right: var(--cell-size);
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[11px\\] {
  padding-left: 11px;
  padding-right: 11px;
}
.px-\\[13px\\] {
  padding-left: 13px;
  padding-right: 13px;
}
.px-\\[14px\\] {
  padding-left: 14px;
  padding-right: 14px;
}
.px-\\[15px\\] {
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[17px\\] {
  padding-left: 17px;
  padding-right: 17px;
}
.px-\\[18px\\] {
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[19px\\] {
  padding-left: 19px;
  padding-right: 19px;
}
.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}
.px-\\[7px\\] {
  padding-left: 7px;
  padding-right: 7px;
}
.px-\\[9px\\] {
  padding-left: 9px;
  padding-right: 9px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-11 {
  padding-top: 2.75rem;
  padding-bottom: 2.75rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-9 {
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}
.py-\\[13px\\] {
  padding-top: 13px;
  padding-bottom: 13px;
}
.py-\\[17px\\] {
  padding-top: 17px;
  padding-bottom: 17px;
}
.py-\\[18px\\] {
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[58px\\] {
  padding-top: 58px;
  padding-bottom: 58px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[7px\\] {
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-\\[9px\\] {
  padding-top: 9px;
  padding-bottom: 9px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-3\\.5 {
  padding-bottom: 0.875rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-\\[15px\\] {
  padding-bottom: 15px;
}
.pb-\\[19px\\] {
  padding-bottom: 19px;
}
.pb-\\[21px\\] {
  padding-bottom: 21px;
}
.pb-\\[35px\\] {
  padding-bottom: 35px;
}
.pl-1\\.5 {
  padding-left: 0.375rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pl-\\[30px\\] {
  padding-left: 30px;
}
.pl-\\[60px\\] {
  padding-left: 60px;
}
.pl-\\[7px\\] {
  padding-left: 7px;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-14 {
  padding-right: 3.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pr-\\[66px\\] {
  padding-right: 66px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pt-11 {
  padding-top: 2.75rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-3\\.5 {
  padding-top: 0.875rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-\\[10px\\] {
  padding-top: 10px;
}
.pt-\\[11px\\] {
  padding-top: 11px;
}
.pt-\\[18px\\] {
  padding-top: 18px;
}
.pt-\\[19px\\] {
  padding-top: 19px;
}
.pt-\\[21px\\] {
  padding-top: 21px;
}
.pt-\\[22px\\] {
  padding-top: 22px;
}
.pt-\\[3px\\] {
  padding-top: 3px;
}
.pt-\\[54px\\] {
  padding-top: 54px;
}
.pt-\\[7px\\] {
  padding-top: 7px;
}
.\\!text-left {
  text-align: left !important;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.font-\\[\\'Inter\\'\\2c Arial\\2c sans-serif\\] {
  font-family: 'Inter',Arial,sans-serif;
}
.font-\\[Inter\\2c sans-serif\\] {
  font-family: Inter,sans-serif;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: var(--font-sans), ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11\\.5px\\] {
  font-size: 11.5px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[19px\\] {
  font-size: 19px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[21px\\] {
  font-size: 21px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[23px\\] {
  font-size: 23px;
}
.text-\\[25px\\] {
  font-size: 25px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[27px\\] {
  font-size: 27px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[33px\\] {
  font-size: 33px;
}
.text-\\[44px\\] {
  font-size: 44px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-sm\\/relaxed {
  font-size: 0.875rem;
  line-height: 1.625;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-9 {
  line-height: 2.25rem;
}
.leading-\\[1\\.18\\] {
  line-height: 1.18;
}
.leading-\\[1\\.2\\] {
  line-height: 1.2;
}
.leading-\\[1\\.3\\] {
  line-height: 1.3;
}
.leading-\\[1\\.4\\] {
  line-height: 1.4;
}
.leading-\\[1\\.55\\] {
  line-height: 1.55;
}
.leading-\\[1\\.5\\] {
  line-height: 1.5;
}
.leading-\\[1\\.65\\] {
  line-height: 1.65;
}
.leading-\\[1\\.6\\] {
  line-height: 1.6;
}
.leading-\\[1\\.75\\] {
  line-height: 1.75;
}
.leading-\\[1\\.7\\] {
  line-height: 1.7;
}
.leading-\\[1\\.8\\] {
  line-height: 1.8;
}
.leading-\\[14px\\] {
  line-height: 14px;
}
.leading-\\[15px\\] {
  line-height: 15px;
}
.leading-\\[17px\\] {
  line-height: 17px;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.leading-\\[19px\\] {
  line-height: 19px;
}
.leading-\\[21px\\] {
  line-height: 21px;
}
.leading-\\[22px\\] {
  line-height: 22px;
}
.leading-\\[25px\\] {
  line-height: 25px;
}
.leading-\\[inherit\\] {
  line-height: inherit;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-0\\.02em\\] {
  letter-spacing: -0.02em;
}
.tracking-\\[-0\\.16px\\] {
  letter-spacing: -0.16px;
}
.tracking-\\[-0\\.25px\\] {
  letter-spacing: -0.25px;
}
.tracking-\\[-0\\.35px\\] {
  letter-spacing: -0.35px;
}
.tracking-\\[-0\\.3px\\] {
  letter-spacing: -0.3px;
}
.tracking-\\[-0\\.55px\\] {
  letter-spacing: -0.55px;
}
.tracking-\\[-0\\.65px\\] {
  letter-spacing: -0.65px;
}
.tracking-\\[-0\\.6px\\] {
  letter-spacing: -0.6px;
}
.tracking-\\[-0\\.7px\\] {
  letter-spacing: -0.7px;
}
.tracking-\\[-0\\.9px\\] {
  letter-spacing: -0.9px;
}
.tracking-\\[-1\\.5px\\] {
  letter-spacing: -1.5px;
}
.tracking-\\[0\\.01em\\] {
  letter-spacing: 0.01em;
}
.tracking-\\[0\\.02em\\] {
  letter-spacing: 0.02em;
}
.tracking-\\[0\\.045em\\] {
  letter-spacing: 0.045em;
}
.tracking-\\[0\\.04em\\] {
  letter-spacing: 0.04em;
}
.tracking-\\[0\\.065em\\] {
  letter-spacing: 0.065em;
}
.tracking-\\[0\\.12em\\] {
  letter-spacing: 0.12em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[\\#00472f\\] {
  --tw-text-opacity: 1;
  color: rgb(0 71 47 / var(--tw-text-opacity, 1));
}
.text-\\[\\#006e46\\] {
  --tw-text-opacity: 1;
  color: rgb(0 110 70 / var(--tw-text-opacity, 1));
}
.text-\\[\\#09624f\\] {
  --tw-text-opacity: 1;
  color: rgb(9 98 79 / var(--tw-text-opacity, 1));
}
.text-\\[\\#18543b\\] {
  --tw-text-opacity: 1;
  color: rgb(24 84 59 / var(--tw-text-opacity, 1));
}
.text-\\[\\#18563b\\] {
  --tw-text-opacity: 1;
  color: rgb(24 86 59 / var(--tw-text-opacity, 1));
}
.text-\\[\\#18834b\\] {
  --tw-text-opacity: 1;
  color: rgb(24 131 75 / var(--tw-text-opacity, 1));
}
.text-\\[\\#195f39\\] {
  --tw-text-opacity: 1;
  color: rgb(25 95 57 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1d2824\\] {
  --tw-text-opacity: 1;
  color: rgb(29 40 36 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1f2937\\] {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-\\[\\#202d28\\] {
  --tw-text-opacity: 1;
  color: rgb(32 45 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#203329\\] {
  --tw-text-opacity: 1;
  color: rgb(32 51 41 / var(--tw-text-opacity, 1));
}
.text-\\[\\#20342a\\] {
  --tw-text-opacity: 1;
  color: rgb(32 52 42 / var(--tw-text-opacity, 1));
}
.text-\\[\\#20372a\\] {
  --tw-text-opacity: 1;
  color: rgb(32 55 42 / var(--tw-text-opacity, 1));
}
.text-\\[\\#206a42\\] {
  --tw-text-opacity: 1;
  color: rgb(32 106 66 / var(--tw-text-opacity, 1));
}
.text-\\[\\#206c40\\] {
  --tw-text-opacity: 1;
  color: rgb(32 108 64 / var(--tw-text-opacity, 1));
}
.text-\\[\\#21312a\\] {
  --tw-text-opacity: 1;
  color: rgb(33 49 42 / var(--tw-text-opacity, 1));
}
.text-\\[\\#22382b\\] {
  --tw-text-opacity: 1;
  color: rgb(34 56 43 / var(--tw-text-opacity, 1));
}
.text-\\[\\#225b3c\\] {
  --tw-text-opacity: 1;
  color: rgb(34 91 60 / var(--tw-text-opacity, 1));
}
.text-\\[\\#24352c\\] {
  --tw-text-opacity: 1;
  color: rgb(36 53 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#24372c\\] {
  --tw-text-opacity: 1;
  color: rgb(36 55 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#24382c\\] {
  --tw-text-opacity: 1;
  color: rgb(36 56 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#24432f\\] {
  --tw-text-opacity: 1;
  color: rgb(36 67 47 / var(--tw-text-opacity, 1));
}
.text-\\[\\#244c34\\] {
  --tw-text-opacity: 1;
  color: rgb(36 76 52 / var(--tw-text-opacity, 1));
}
.text-\\[\\#246641\\] {
  --tw-text-opacity: 1;
  color: rgb(36 102 65 / var(--tw-text-opacity, 1));
}
.text-\\[\\#247e6e\\] {
  --tw-text-opacity: 1;
  color: rgb(36 126 110 / var(--tw-text-opacity, 1));
}
.text-\\[\\#252a30\\] {
  --tw-text-opacity: 1;
  color: rgb(37 42 48 / var(--tw-text-opacity, 1));
}
.text-\\[\\#25382d\\] {
  --tw-text-opacity: 1;
  color: rgb(37 56 45 / var(--tw-text-opacity, 1));
}
.text-\\[\\#256547\\] {
  --tw-text-opacity: 1;
  color: rgb(37 101 71 / var(--tw-text-opacity, 1));
}
.text-\\[\\#26323f\\] {
  --tw-text-opacity: 1;
  color: rgb(38 50 63 / var(--tw-text-opacity, 1));
}
.text-\\[\\#26352c\\] {
  --tw-text-opacity: 1;
  color: rgb(38 53 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#263e2e\\] {
  --tw-text-opacity: 1;
  color: rgb(38 62 46 / var(--tw-text-opacity, 1));
}
.text-\\[\\#264232\\] {
  --tw-text-opacity: 1;
  color: rgb(38 66 50 / var(--tw-text-opacity, 1));
}
.text-\\[\\#27342e\\] {
  --tw-text-opacity: 1;
  color: rgb(39 52 46 / var(--tw-text-opacity, 1));
}
.text-\\[\\#27382e\\] {
  --tw-text-opacity: 1;
  color: rgb(39 56 46 / var(--tw-text-opacity, 1));
}
.text-\\[\\#27392f\\] {
  --tw-text-opacity: 1;
  color: rgb(39 57 47 / var(--tw-text-opacity, 1));
}
.text-\\[\\#273b2f\\] {
  --tw-text-opacity: 1;
  color: rgb(39 59 47 / var(--tw-text-opacity, 1));
}
.text-\\[\\#276e49\\] {
  --tw-text-opacity: 1;
  color: rgb(39 110 73 / var(--tw-text-opacity, 1));
}
.text-\\[\\#284333\\] {
  --tw-text-opacity: 1;
  color: rgb(40 67 51 / var(--tw-text-opacity, 1));
}
.text-\\[\\#286d47\\] {
  --tw-text-opacity: 1;
  color: rgb(40 109 71 / var(--tw-text-opacity, 1));
}
.text-\\[\\#28764d\\] {
  --tw-text-opacity: 1;
  color: rgb(40 118 77 / var(--tw-text-opacity, 1));
}
.text-\\[\\#294234\\] {
  --tw-text-opacity: 1;
  color: rgb(41 66 52 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2a6948\\] {
  --tw-text-opacity: 1;
  color: rgb(42 105 72 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2b3d31\\] {
  --tw-text-opacity: 1;
  color: rgb(43 61 49 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2b3e32\\] {
  --tw-text-opacity: 1;
  color: rgb(43 62 50 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2c8155\\] {
  --tw-text-opacity: 1;
  color: rgb(44 129 85 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2d4737\\] {
  --tw-text-opacity: 1;
  color: rgb(45 71 55 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2e4034\\] {
  --tw-text-opacity: 1;
  color: rgb(46 64 52 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2e4636\\] {
  --tw-text-opacity: 1;
  color: rgb(46 70 54 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2e7650\\] {
  --tw-text-opacity: 1;
  color: rgb(46 118 80 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2f3e35\\] {
  --tw-text-opacity: 1;
  color: rgb(47 62 53 / var(--tw-text-opacity, 1));
}
.text-\\[\\#30372d\\] {
  --tw-text-opacity: 1;
  color: rgb(48 55 45 / var(--tw-text-opacity, 1));
}
.text-\\[\\#304238\\] {
  --tw-text-opacity: 1;
  color: rgb(48 66 56 / var(--tw-text-opacity, 1));
}
.text-\\[\\#30483a\\] {
  --tw-text-opacity: 1;
  color: rgb(48 72 58 / var(--tw-text-opacity, 1));
}
.text-\\[\\#315c43\\] {
  --tw-text-opacity: 1;
  color: rgb(49 92 67 / var(--tw-text-opacity, 1));
}
.text-\\[\\#316c48\\] {
  --tw-text-opacity: 1;
  color: rgb(49 108 72 / var(--tw-text-opacity, 1));
}
.text-\\[\\#317791\\] {
  --tw-text-opacity: 1;
  color: rgb(49 119 145 / var(--tw-text-opacity, 1));
}
.text-\\[\\#326491\\] {
  --tw-text-opacity: 1;
  color: rgb(50 100 145 / var(--tw-text-opacity, 1));
}
.text-\\[\\#33463b\\] {
  --tw-text-opacity: 1;
  color: rgb(51 70 59 / var(--tw-text-opacity, 1));
}
.text-\\[\\#334a3b\\] {
  --tw-text-opacity: 1;
  color: rgb(51 74 59 / var(--tw-text-opacity, 1));
}
.text-\\[\\#344239\\] {
  --tw-text-opacity: 1;
  color: rgb(52 66 57 / var(--tw-text-opacity, 1));
}
.text-\\[\\#34463b\\] {
  --tw-text-opacity: 1;
  color: rgb(52 70 59 / var(--tw-text-opacity, 1));
}
.text-\\[\\#34483a\\] {
  --tw-text-opacity: 1;
  color: rgb(52 72 58 / var(--tw-text-opacity, 1));
}
.text-\\[\\#34483b\\] {
  --tw-text-opacity: 1;
  color: rgb(52 72 59 / var(--tw-text-opacity, 1));
}
.text-\\[\\#344e3c\\] {
  --tw-text-opacity: 1;
  color: rgb(52 78 60 / var(--tw-text-opacity, 1));
}
.text-\\[\\#344f3d\\] {
  --tw-text-opacity: 1;
  color: rgb(52 79 61 / var(--tw-text-opacity, 1));
}
.text-\\[\\#354139\\] {
  --tw-text-opacity: 1;
  color: rgb(53 65 57 / var(--tw-text-opacity, 1));
}
.text-\\[\\#35473b\\] {
  --tw-text-opacity: 1;
  color: rgb(53 71 59 / var(--tw-text-opacity, 1));
}
.text-\\[\\#354c3c\\] {
  --tw-text-opacity: 1;
  color: rgb(53 76 60 / var(--tw-text-opacity, 1));
}
.text-\\[\\#35734e\\] {
  --tw-text-opacity: 1;
  color: rgb(53 115 78 / var(--tw-text-opacity, 1));
}
.text-\\[\\#366449\\] {
  --tw-text-opacity: 1;
  color: rgb(54 100 73 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3a4e41\\] {
  --tw-text-opacity: 1;
  color: rgb(58 78 65 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3c5143\\] {
  --tw-text-opacity: 1;
  color: rgb(60 81 67 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3d434a\\] {
  --tw-text-opacity: 1;
  color: rgb(61 67 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3d6850\\] {
  --tw-text-opacity: 1;
  color: rgb(61 104 80 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3e4742\\] {
  --tw-text-opacity: 1;
  color: rgb(62 71 66 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3e5144\\] {
  --tw-text-opacity: 1;
  color: rgb(62 81 68 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3e624d\\] {
  --tw-text-opacity: 1;
  color: rgb(62 98 77 / var(--tw-text-opacity, 1));
}
.text-\\[\\#405345\\] {
  --tw-text-opacity: 1;
  color: rgb(64 83 69 / var(--tw-text-opacity, 1));
}
.text-\\[\\#405d49\\] {
  --tw-text-opacity: 1;
  color: rgb(64 93 73 / var(--tw-text-opacity, 1));
}
.text-\\[\\#424c45\\] {
  --tw-text-opacity: 1;
  color: rgb(66 76 69 / var(--tw-text-opacity, 1));
}
.text-\\[\\#42594a\\] {
  --tw-text-opacity: 1;
  color: rgb(66 89 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#455349\\] {
  --tw-text-opacity: 1;
  color: rgb(69 83 73 / var(--tw-text-opacity, 1));
}
.text-\\[\\#46594d\\] {
  --tw-text-opacity: 1;
  color: rgb(70 89 77 / var(--tw-text-opacity, 1));
}
.text-\\[\\#477159\\] {
  --tw-text-opacity: 1;
  color: rgb(71 113 89 / var(--tw-text-opacity, 1));
}
.text-\\[\\#486154\\] {
  --tw-text-opacity: 1;
  color: rgb(72 97 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#48688a\\] {
  --tw-text-opacity: 1;
  color: rgb(72 104 138 / var(--tw-text-opacity, 1));
}
.text-\\[\\#495b50\\] {
  --tw-text-opacity: 1;
  color: rgb(73 91 80 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4b735c\\] {
  --tw-text-opacity: 1;
  color: rgb(75 115 92 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4c5f52\\] {
  --tw-text-opacity: 1;
  color: rgb(76 95 82 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4d6a37\\] {
  --tw-text-opacity: 1;
  color: rgb(77 106 55 / var(--tw-text-opacity, 1));
}
.text-\\[\\#526158\\] {
  --tw-text-opacity: 1;
  color: rgb(82 97 88 / var(--tw-text-opacity, 1));
}
.text-\\[\\#52645a\\] {
  --tw-text-opacity: 1;
  color: rgb(82 100 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#52665a\\] {
  --tw-text-opacity: 1;
  color: rgb(82 102 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#52675b\\] {
  --tw-text-opacity: 1;
  color: rgb(82 103 91 / var(--tw-text-opacity, 1));
}
.text-\\[\\#528064\\] {
  --tw-text-opacity: 1;
  color: rgb(82 128 100 / var(--tw-text-opacity, 1));
}
.text-\\[\\#536157\\] {
  --tw-text-opacity: 1;
  color: rgb(83 97 87 / var(--tw-text-opacity, 1));
}
.text-\\[\\#53645a\\] {
  --tw-text-opacity: 1;
  color: rgb(83 100 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#53655a\\] {
  --tw-text-opacity: 1;
  color: rgb(83 101 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#53675a\\] {
  --tw-text-opacity: 1;
  color: rgb(83 103 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#53685b\\] {
  --tw-text-opacity: 1;
  color: rgb(83 104 91 / var(--tw-text-opacity, 1));
}
.text-\\[\\#536b5a\\] {
  --tw-text-opacity: 1;
  color: rgb(83 107 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#536b5b\\] {
  --tw-text-opacity: 1;
  color: rgb(83 107 91 / var(--tw-text-opacity, 1));
}
.text-\\[\\#55675d\\] {
  --tw-text-opacity: 1;
  color: rgb(85 103 93 / var(--tw-text-opacity, 1));
}
.text-\\[\\#557064\\] {
  --tw-text-opacity: 1;
  color: rgb(85 112 100 / var(--tw-text-opacity, 1));
}
.text-\\[\\#56665b\\] {
  --tw-text-opacity: 1;
  color: rgb(86 102 91 / var(--tw-text-opacity, 1));
}
.text-\\[\\#56675b\\] {
  --tw-text-opacity: 1;
  color: rgb(86 103 91 / var(--tw-text-opacity, 1));
}
.text-\\[\\#566f82\\] {
  --tw-text-opacity: 1;
  color: rgb(86 111 130 / var(--tw-text-opacity, 1));
}
.text-\\[\\#586357\\] {
  --tw-text-opacity: 1;
  color: rgb(88 99 87 / var(--tw-text-opacity, 1));
}
.text-\\[\\#586b60\\] {
  --tw-text-opacity: 1;
  color: rgb(88 107 96 / var(--tw-text-opacity, 1));
}
.text-\\[\\#596c60\\] {
  --tw-text-opacity: 1;
  color: rgb(89 108 96 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5f6875\\] {
  --tw-text-opacity: 1;
  color: rgb(95 104 117 / var(--tw-text-opacity, 1));
}
.text-\\[\\#607165\\] {
  --tw-text-opacity: 1;
  color: rgb(96 113 101 / var(--tw-text-opacity, 1));
}
.text-\\[\\#617365\\] {
  --tw-text-opacity: 1;
  color: rgb(97 115 101 / var(--tw-text-opacity, 1));
}
.text-\\[\\#61766a\\] {
  --tw-text-opacity: 1;
  color: rgb(97 118 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#61786a\\] {
  --tw-text-opacity: 1;
  color: rgb(97 120 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#61796a\\] {
  --tw-text-opacity: 1;
  color: rgb(97 121 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#62736a\\] {
  --tw-text-opacity: 1;
  color: rgb(98 115 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#63716a\\] {
  --tw-text-opacity: 1;
  color: rgb(99 113 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#637469\\] {
  --tw-text-opacity: 1;
  color: rgb(99 116 105 / var(--tw-text-opacity, 1));
}
.text-\\[\\#64746a\\] {
  --tw-text-opacity: 1;
  color: rgb(100 116 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#64756a\\] {
  --tw-text-opacity: 1;
  color: rgb(100 117 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#64836e\\] {
  --tw-text-opacity: 1;
  color: rgb(100 131 110 / var(--tw-text-opacity, 1));
}
.text-\\[\\#657269\\] {
  --tw-text-opacity: 1;
  color: rgb(101 114 105 / var(--tw-text-opacity, 1));
}
.text-\\[\\#65766c\\] {
  --tw-text-opacity: 1;
  color: rgb(101 118 108 / var(--tw-text-opacity, 1));
}
.text-\\[\\#66736d\\] {
  --tw-text-opacity: 1;
  color: rgb(102 115 109 / var(--tw-text-opacity, 1));
}
.text-\\[\\#667582\\] {
  --tw-text-opacity: 1;
  color: rgb(102 117 130 / var(--tw-text-opacity, 1));
}
.text-\\[\\#66766c\\] {
  --tw-text-opacity: 1;
  color: rgb(102 118 108 / var(--tw-text-opacity, 1));
}
.text-\\[\\#67726b\\] {
  --tw-text-opacity: 1;
  color: rgb(103 114 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#68766d\\] {
  --tw-text-opacity: 1;
  color: rgb(104 118 109 / var(--tw-text-opacity, 1));
}
.text-\\[\\#68776e\\] {
  --tw-text-opacity: 1;
  color: rgb(104 119 110 / var(--tw-text-opacity, 1));
}
.text-\\[\\#68796e\\] {
  --tw-text-opacity: 1;
  color: rgb(104 121 110 / var(--tw-text-opacity, 1));
}
.text-\\[\\#687b6e\\] {
  --tw-text-opacity: 1;
  color: rgb(104 123 110 / var(--tw-text-opacity, 1));
}
.text-\\[\\#687c6e\\] {
  --tw-text-opacity: 1;
  color: rgb(104 124 110 / var(--tw-text-opacity, 1));
}
.text-\\[\\#69776e\\] {
  --tw-text-opacity: 1;
  color: rgb(105 119 110 / var(--tw-text-opacity, 1));
}
.text-\\[\\#698271\\] {
  --tw-text-opacity: 1;
  color: rgb(105 130 113 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6a766f\\] {
  --tw-text-opacity: 1;
  color: rgb(106 118 111 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6a7770\\] {
  --tw-text-opacity: 1;
  color: rgb(106 119 112 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6a7c70\\] {
  --tw-text-opacity: 1;
  color: rgb(106 124 112 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6b7772\\] {
  --tw-text-opacity: 1;
  color: rgb(107 119 114 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6c7970\\] {
  --tw-text-opacity: 1;
  color: rgb(108 121 112 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6d7d72\\] {
  --tw-text-opacity: 1;
  color: rgb(109 125 114 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6e7b72\\] {
  --tw-text-opacity: 1;
  color: rgb(110 123 114 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6f7c74\\] {
  --tw-text-opacity: 1;
  color: rgb(111 124 116 / var(--tw-text-opacity, 1));
}
.text-\\[\\#708075\\] {
  --tw-text-opacity: 1;
  color: rgb(112 128 117 / var(--tw-text-opacity, 1));
}
.text-\\[\\#708078\\] {
  --tw-text-opacity: 1;
  color: rgb(112 128 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#708677\\] {
  --tw-text-opacity: 1;
  color: rgb(112 134 119 / var(--tw-text-opacity, 1));
}
.text-\\[\\#717b74\\] {
  --tw-text-opacity: 1;
  color: rgb(113 123 116 / var(--tw-text-opacity, 1));
}
.text-\\[\\#718178\\] {
  --tw-text-opacity: 1;
  color: rgb(113 129 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#727e74\\] {
  --tw-text-opacity: 1;
  color: rgb(114 126 116 / var(--tw-text-opacity, 1));
}
.text-\\[\\#728076\\] {
  --tw-text-opacity: 1;
  color: rgb(114 128 118 / var(--tw-text-opacity, 1));
}
.text-\\[\\#728278\\] {
  --tw-text-opacity: 1;
  color: rgb(114 130 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#737d75\\] {
  --tw-text-opacity: 1;
  color: rgb(115 125 117 / var(--tw-text-opacity, 1));
}
.text-\\[\\#738078\\] {
  --tw-text-opacity: 1;
  color: rgb(115 128 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#738079\\] {
  --tw-text-opacity: 1;
  color: rgb(115 128 121 / var(--tw-text-opacity, 1));
}
.text-\\[\\#738279\\] {
  --tw-text-opacity: 1;
  color: rgb(115 130 121 / var(--tw-text-opacity, 1));
}
.text-\\[\\#738378\\] {
  --tw-text-opacity: 1;
  color: rgb(115 131 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#747b76\\] {
  --tw-text-opacity: 1;
  color: rgb(116 123 118 / var(--tw-text-opacity, 1));
}
.text-\\[\\#747d78\\] {
  --tw-text-opacity: 1;
  color: rgb(116 125 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#748078\\] {
  --tw-text-opacity: 1;
  color: rgb(116 128 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#748178\\] {
  --tw-text-opacity: 1;
  color: rgb(116 129 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#755097\\] {
  --tw-text-opacity: 1;
  color: rgb(117 80 151 / var(--tw-text-opacity, 1));
}
.text-\\[\\#758178\\] {
  --tw-text-opacity: 1;
  color: rgb(117 129 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#778279\\] {
  --tw-text-opacity: 1;
  color: rgb(119 130 121 / var(--tw-text-opacity, 1));
}
.text-\\[\\#77877c\\] {
  --tw-text-opacity: 1;
  color: rgb(119 135 124 / var(--tw-text-opacity, 1));
}
.text-\\[\\#78837c\\] {
  --tw-text-opacity: 1;
  color: rgb(120 131 124 / var(--tw-text-opacity, 1));
}
.text-\\[\\#78847c\\] {
  --tw-text-opacity: 1;
  color: rgb(120 132 124 / var(--tw-text-opacity, 1));
}
.text-\\[\\#78857d\\] {
  --tw-text-opacity: 1;
  color: rgb(120 133 125 / var(--tw-text-opacity, 1));
}
.text-\\[\\#79847e\\] {
  --tw-text-opacity: 1;
  color: rgb(121 132 126 / var(--tw-text-opacity, 1));
}
.text-\\[\\#79867d\\] {
  --tw-text-opacity: 1;
  color: rgb(121 134 125 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7a857e\\] {
  --tw-text-opacity: 1;
  color: rgb(122 133 126 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7a877f\\] {
  --tw-text-opacity: 1;
  color: rgb(122 135 127 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7b867e\\] {
  --tw-text-opacity: 1;
  color: rgb(123 134 126 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7b9080\\] {
  --tw-text-opacity: 1;
  color: rgb(123 144 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7c2d12\\] {
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7c8881\\] {
  --tw-text-opacity: 1;
  color: rgb(124 136 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7c8980\\] {
  --tw-text-opacity: 1;
  color: rgb(124 137 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#819588\\] {
  --tw-text-opacity: 1;
  color: rgb(129 149 136 / var(--tw-text-opacity, 1));
}
.text-\\[\\#896023\\] {
  --tw-text-opacity: 1;
  color: rgb(137 96 35 / var(--tw-text-opacity, 1));
}
.text-\\[\\#896400\\] {
  --tw-text-opacity: 1;
  color: rgb(137 100 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#89958d\\] {
  --tw-text-opacity: 1;
  color: rgb(137 149 141 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8a938d\\] {
  --tw-text-opacity: 1;
  color: rgb(138 147 141 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8a978f\\] {
  --tw-text-opacity: 1;
  color: rgb(138 151 143 / var(--tw-text-opacity, 1));
}
.text-\\[\\#91a095\\] {
  --tw-text-opacity: 1;
  color: rgb(145 160 149 / var(--tw-text-opacity, 1));
}
.text-\\[\\#946b36\\] {
  --tw-text-opacity: 1;
  color: rgb(148 107 54 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9a3412\\] {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a34242\\] {
  --tw-text-opacity: 1;
  color: rgb(163 66 66 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a34838\\] {
  --tw-text-opacity: 1;
  color: rgb(163 72 56 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a54b61\\] {
  --tw-text-opacity: 1;
  color: rgb(165 75 97 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a74b54\\] {
  --tw-text-opacity: 1;
  color: rgb(167 75 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a83e3e\\] {
  --tw-text-opacity: 1;
  color: rgb(168 62 62 / var(--tw-text-opacity, 1));
}
.text-\\[\\#aa4545\\] {
  --tw-text-opacity: 1;
  color: rgb(170 69 69 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ae3542\\] {
  --tw-text-opacity: 1;
  color: rgb(174 53 66 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b13c47\\] {
  --tw-text-opacity: 1;
  color: rgb(177 60 71 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b45a43\\] {
  --tw-text-opacity: 1;
  color: rgb(180 90 67 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b52535\\] {
  --tw-text-opacity: 1;
  color: rgb(181 37 53 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b96060\\] {
  --tw-text-opacity: 1;
  color: rgb(185 96 96 / var(--tw-text-opacity, 1));
}
.text-\\[\\#dce7df\\] {
  --tw-text-opacity: 1;
  color: rgb(220 231 223 / var(--tw-text-opacity, 1));
}
.text-\\[\\#e3ebe5\\] {
  --tw-text-opacity: 1;
  color: rgb(227 235 229 / var(--tw-text-opacity, 1));
}
.text-accent-foreground {
  color: var(--accent-foreground);
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-card-foreground {
  color: var(--card-foreground);
}
.text-current {
  color: currentColor;
}
.text-destructive {
  color: var(--destructive);
}
.text-destructive-foreground {
  color: var(--destructive-foreground);
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-foreground {
  color: var(--foreground);
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-hajj-primary {
  color: var(--hajj-primary);
}
.text-inherit {
  color: inherit;
}
.text-muted-foreground {
  color: var(--muted-foreground);
}
.text-popover-foreground {
  color: var(--popover-foreground);
}
.text-primary {
  color: var(--primary);
}
.text-primary-foreground {
  color: var(--primary-foreground);
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground {
  color: var(--secondary-foreground);
}
.text-sidebar-foreground {
  color: var(--sidebar-foreground);
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.underline {
  text-decoration-line: underline;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-65 {
  opacity: 0.65;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-\\[0\\.85\\] {
  opacity: 0.85;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-border\\)\\)\\] {
  --tw-shadow: 0 0 0 1px hsl(var(--sidebar-border));
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_rgba\\(49\\2c 129\\2c 83\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 0 0 1px rgba(49,129,83,0.12);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_40px_rgba\\(32\\2c 48\\2c 39\\2c 0\\.10\\)\\] {
  --tw-shadow: 0 12px 40px rgba(32,48,39,0.10);
  --tw-shadow-colored: 0 12px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_70px_rgba\\(20\\2c 42\\2c 37\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 16px 70px rgba(20,42,37,0.2);
  --tw-shadow-colored: 0 16px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_60px_\\#132a2522\\] {
  --tw-shadow: 0 18px 60px #132a2522;
  --tw-shadow-colored: 0 18px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_60px_\\#14231b24\\] {
  --tw-shadow: 0 18px 60px #14231b24;
  --tw-shadow-colored: 0 18px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_60px_\\#15281d26\\] {
  --tw-shadow: 0 18px 60px #15281d26;
  --tw-shadow-colored: 0 18px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_65px_\\#18362b26\\] {
  --tw-shadow: 0 18px 65px #18362b26;
  --tw-shadow-colored: 0 18px 65px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(18\\2c 43\\2c 30\\2c 0\\.01\\)\\] {
  --tw-shadow: 0 1px 2px rgba(18,43,30,0.01);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_4px_rgba\\(30\\2c 54\\2c 35\\2c 0\\.03\\)\\] {
  --tw-shadow: 0 2px 4px rgba(30,54,35,0.03);
  --tw-shadow-colored: 0 2px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_5px_15px_\\#1d3b2914\\] {
  --tw-shadow: 0 5px 15px #1d3b2914;
  --tw-shadow-colored: 0 5px 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_5px_16px_rgba\\(30\\2c 53\\2c 37\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 5px 16px rgba(30,53,37,0.06);
  --tw-shadow-colored: 0 5px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_20px_rgba\\(32\\2c 56\\2c 43\\2c 0\\.07\\)\\2c 0_2px_4px_rgba\\(32\\2c 56\\2c 43\\2c 0\\.03\\)\\] {
  --tw-shadow: 0 6px 20px rgba(32,56,43,0.07),0 2px 4px rgba(32,56,43,0.03);
  --tw-shadow-colored: 0 6px 20px var(--tw-shadow-color), 0 2px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_20px_rgba\\(32\\2c 57\\2c 39\\2c 0\\.10\\)\\] {
  --tw-shadow: 0 6px 20px rgba(32,57,39,0.10);
  --tw-shadow-colored: 0 6px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_24px_\\#182d201c\\] {
  --tw-shadow: 0 6px 24px #182d201c;
  --tw-shadow-colored: 0 6px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_24px_\\#1a34231a\\] {
  --tw-shadow: 0 6px 24px #1a34231a;
  --tw-shadow-colored: 0 6px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgba\\(29\\2c 57\\2c 34\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 30px rgba(29,57,34,0.1);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[1px_0_0_\\#e1e7e2\\] {
  --tw-shadow: 1px 0 0 #e1e7e2;
  --tw-shadow-colored: 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_-3px_\\#007e61\\] {
  --tw-shadow: inset 0 -3px #007e61;
  --tw-shadow-colored: inset 0 -3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_0_1px_\\#96bea3\\] {
  --tw-shadow: inset 0 0 0 1px #96bea3;
  --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-ring {
  --tw-ring-color: var(--ring);
}
.ring-sidebar-ring {
  --tw-ring-color: var(--sidebar-ring);
}
.ring-offset-background {
  --tw-ring-offset-color: var(--background);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[left\\2c right\\2c width\\] {
  transition-property: left,right,width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[margin\\2c opacity\\] {
  transition-property: margin,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\2c height\\2c padding\\] {
  transition-property: width,height,padding;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  transition-timing-function: linear;
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in {
  --tw-enter-opacity: 0;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.slide-in-from-bottom-4 {
  --tw-enter-translate-y: 1rem;
}
.slide-in-from-right-4 {
  --tw-enter-translate-x: 1rem;
}
.duration-100 {
  animation-duration: 100ms;
}
.duration-1000 {
  animation-duration: 1000ms;
}
.duration-150 {
  animation-duration: 150ms;
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.duration-500 {
  animation-duration: 500ms;
}
.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  animation-timing-function: linear;
}
.\\[--cell-size\\:2\\.5rem\\] {
  --cell-size: 2.5rem;
}
.\\[container-type\\:inline-size\\] {
  container-type: inline-size;
}
.\\[font-family\\:Inter\\2c sans-serif\\] {
  font-family: Inter,sans-serif;
}
.\\[font-weight\\:550\\] {
  font-weight: 550;
}
.\\[scrollbar-color\\:\\#c2cec5_transparent\\] {
  scrollbar-color: #c2cec5 transparent;
}
.\\[scrollbar-color\\:\\#c8d0cb_transparent\\] {
  scrollbar-color: #c8d0cb transparent;
}
.\\[scrollbar-color\\:\\#c9d3cc_transparent\\] {
  scrollbar-color: #c9d3cc transparent;
}
.\\[scrollbar-color\\:\\#e6ebe7_transparent\\] {
  scrollbar-color: #e6ebe7 transparent;
}
.\\[scrollbar-gutter\\:stable\\] {
  scrollbar-gutter: stable;
}
.\\[scrollbar-width\\:thin\\] {
  scrollbar-width: thin;
}
.\\[stroke-width\\:1\\.85\\] {
  stroke-width: 1.85;
}
.\\[stroke-width\\:2\\] {
  stroke-width: 2;
}

@custom-variant dark (&:is(.dark *));

.marker\\:text-\\[\\#637568\\] *::marker {
  color: rgb(99 117 104 );
}

.marker\\:text-\\[\\#637568\\]::marker {
  color: rgb(99 117 104 );
}

.file\\:border-0::file-selector-button {
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}

.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button {
  font-weight: 500;
}

.file\\:text-foreground::file-selector-button {
  color: var(--foreground);
}

.placeholder\\:text-xs::placeholder {
  font-size: 0.75rem;
  line-height: 1rem;
}

.placeholder\\:text-\\[\\#5f6875\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(95 104 117 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-\\[\\#88928d\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(136 146 141 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-gray-500::placeholder {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-muted-foreground::placeholder {
  color: var(--muted-foreground);
}

.before\\:mb-\\[10px\\]::before {
  content: var(--tw-content);
  margin-bottom: 10px;
}

.before\\:ml-\\[3px\\]::before {
  content: var(--tw-content);
  margin-left: 3px;
}

.before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.before\\:h-px::before {
  content: var(--tw-content);
  height: 1px;
}

.before\\:w-\\[calc\\(100\\%-6px\\)\\]::before {
  content: var(--tw-content);
  width: calc(100% - 6px);
}

.before\\:bg-\\[\\#e1e7e3\\]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(225 231 227 / var(--tw-bg-opacity, 1));
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:-inset-2::after {
  content: var(--tw-content);
  inset: -0.5rem;
}

.after\\:inset-y-0::after {
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}

.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}

.after\\:w-\\[2px\\]::after {
  content: var(--tw-content);
  width: 2px;
}

.first\\:rounded-l-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.first\\:border-l:first-child {
  border-left-width: 1px;
}

.first\\:pt-\\[3px\\]:first-child {
  padding-top: 3px;
}

.last\\:mb-0:last-child {
  margin-bottom: 0px;
}

.last\\:rounded-r-md:last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.last\\:border-0:last-child {
  border-width: 0px;
}

.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}

.last\\:pb-0:last-child {
  padding-bottom: 0px;
}

.read-only\\:bg-\\[\\#f7f9f7\\]:read-only {
  --tw-bg-opacity: 1;
  background-color: rgb(247 249 247 / var(--tw-bg-opacity, 1));
}

.focus-within\\:z-10:focus-within {
  z-index: 10;
}

.focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-\\[\\#287c50\\]\\/30:focus-within {
  --tw-ring-color: rgb(40 124 80 / 0.3);
}

.focus-within\\:ring-hajj-primary:focus-within {
  --tw-ring-color: var(--hajj-primary);
}

.focus-within\\:ring-ring:focus-within {
  --tw-ring-color: var(--ring);
}

.focus-within\\:ring-offset-1:focus-within {
  --tw-ring-offset-width: 1px;
}

.focus-within\\:\\[scrollbar-color\\:\\#c9d3cc_transparent\\]:focus-within {
  scrollbar-color: #c9d3cc transparent;
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-\\[\\#17613d\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(23 97 61 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#8bad97\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(139 173 151 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#9cbcaa\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(156 188 170 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#a6bbaa\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(166 187 170 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#a6bdb0\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(166 189 176 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#a9c2b1\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(169 194 177 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#aebfb2\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(174 191 178 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#b9c6be\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(185 198 190 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#dce7df\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(220 231 223 / var(--tw-border-opacity, 1));
}

.hover\\:border-hajj-primary:hover {
  border-color: var(--hajj-primary);
}

.hover\\:\\!bg-\\[\\#246e48\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(36 110 72 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#003e2b\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 62 43 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#17613d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(23 97 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#246e48\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(36 110 72 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#bbddc3\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(187 221 195 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e3eee7\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(227 238 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e5f1e8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 241 232 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e6ece7\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(230 236 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e7ede9\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(231 237 233 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e7efea\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(231 239 234 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e9f1eb\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 241 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#eaf2ec\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 242 236 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#eaf3ed\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 243 237 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#edf0ee\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(237 240 238 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#edf3ef\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(237 243 239 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#edf4ef\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(237 244 239 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#edf5ef\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(237 245 239 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#eef3ef\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 243 239 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#eff9f5\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 249 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f0f2f1\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 242 241 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f0f3f0\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 243 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f1f4f2\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 244 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f1f8f4\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 248 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f4f6f4\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 246 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f4f7f5\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 247 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f5f8f5\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f6f8f6\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f6f8f7\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 247 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f7faf8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(247 250 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f7fbf8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(247 251 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#fafbfa\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 251 250 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#fafcfb\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 252 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#fbfcfb\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 252 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#ffe3e8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 227 232 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#fff0f2\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 240 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-accent:hover {
  background-color: var(--accent);
}

.hover\\:bg-emerald-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-hajj-secondary:hover {
  background-color: var(--hajj-secondary);
}

.hover\\:bg-muted:hover {
  background-color: var(--muted);
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-sidebar-accent:hover {
  background-color: var(--sidebar-accent);
}

.hover\\:bg-transparent:hover {
  background-color: transparent;
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/15:hover {
  background-color: rgb(255 255 255 / 0.15);
}

.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:text-\\[\\#267147\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(38 113 71 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#2f6746\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(47 103 70 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#326346\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(50 99 70 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#3b5344\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(59 83 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#4b5850\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(75 88 80 / var(--tw-text-opacity, 1));
}

.hover\\:text-accent-foreground:hover {
  color: var(--accent-foreground);
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-hajj-primary:hover {
  color: var(--hajj-primary);
}

.hover\\:text-hajj-secondary:hover {
  color: var(--hajj-secondary);
}

.hover\\:text-muted-foreground:hover {
  color: var(--muted-foreground);
}

.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-sidebar-accent-foreground:hover {
  color: var(--sidebar-accent-foreground);
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-accent\\)\\)\\]:hover {
  --tw-shadow: 0 0 0 1px hsl(var(--sidebar-accent));
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-none:hover {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:\\[scrollbar-color\\:\\#c9d3cc_transparent\\]:hover {
  scrollbar-color: #c9d3cc transparent;
}

.hover\\:after\\:bg-sidebar-border:hover::after {
  content: var(--tw-content);
  background-color: var(--sidebar-border);
}

.focus\\:top-2:focus {
  top: 0.5rem;
}

.focus\\:border-hajj-primary:focus {
  border-color: var(--hajj-primary);
}

.focus\\:bg-\\[\\#f4f7f5\\]:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(244 247 245 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-\\[\\#f5f8f6\\]:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 246 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-\\[\\#fff3f4\\]:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 243 244 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-accent:focus {
  background-color: var(--accent);
}

.focus\\:text-\\[\\#263e2e\\]:focus {
  --tw-text-opacity: 1;
  color: rgb(38 62 46 / var(--tw-text-opacity, 1));
}

.focus\\:text-\\[\\#b52535\\]:focus {
  --tw-text-opacity: 1;
  color: rgb(181 37 53 / var(--tw-text-opacity, 1));
}

.focus\\:text-accent-foreground:focus {
  color: var(--accent-foreground);
}

.focus\\:text-red-700:focus {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.focus\\:\\!outline-none:focus {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[\\#287c50\\]\\/20:focus {
  --tw-ring-color: rgb(40 124 80 / 0.2);
}

.focus\\:ring-hajj-primary:focus {
  --tw-ring-color: var(--hajj-primary);
}

.focus\\:ring-ring:focus {
  --tw-ring-color: var(--ring);
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:rounded-sm:focus-visible {
  border-radius: calc(var(--radius) - 4px);
}

.focus-visible\\:border-\\[\\#287c50\\]:focus-visible {
  --tw-border-opacity: 1;
  border-color: rgb(40 124 80 / var(--tw-border-opacity, 1));
}

.focus-visible\\:border-\\[\\#669980\\]:focus-visible {
  --tw-border-opacity: 1;
  border-color: rgb(102 153 128 / var(--tw-border-opacity, 1));
}

.focus-visible\\:border-hajj-primary:focus-visible {
  border-color: var(--hajj-primary);
}

.focus-visible\\:border-ring:focus-visible {
  border-color: var(--ring);
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:outline:focus-visible {
  outline-style: solid;
}

.focus-visible\\:outline-2:focus-visible {
  outline-width: 2px;
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-\\[3px\\]:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-inset:focus-visible {
  --tw-ring-inset: inset;
}

.focus-visible\\:ring-\\[\\#287c50\\]\\/20:focus-visible {
  --tw-ring-color: rgb(40 124 80 / 0.2);
}

.focus-visible\\:ring-\\[\\#2c8155\\]:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(44 129 85 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-\\[\\#2c8155\\]\\/10:focus-visible {
  --tw-ring-color: rgb(44 129 85 / 0.1);
}

.focus-visible\\:ring-\\[\\#78a488\\]:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(120 164 136 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-\\[rgba\\(43\\2c 123\\2c 83\\2c 0\\.10\\)\\]:focus-visible {
  --tw-ring-color: rgba(43,123,83,0.10);
}

.focus-visible\\:ring-hajj-primary:focus-visible {
  --tw-ring-color: var(--hajj-primary);
}

.focus-visible\\:ring-red-500:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: var(--ring);
}

.focus-visible\\:ring-sidebar-ring:focus-visible {
  --tw-ring-color: var(--sidebar-ring);
}

.focus-visible\\:ring-white\\/80:focus-visible {
  --tw-ring-color: rgb(255 255 255 / 0.8);
}

.focus-visible\\:ring-offset-0:focus-visible {
  --tw-ring-offset-width: 0px;
}

.focus-visible\\:ring-offset-1:focus-visible {
  --tw-ring-offset-width: 1px;
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: var(--background);
}

.active\\:bg-sidebar-accent:active {
  background-color: var(--sidebar-accent);
}

.active\\:text-sidebar-accent-foreground:active {
  color: var(--sidebar-accent-foreground);
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-default:disabled {
  cursor: default;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:cursor-wait:disabled {
  cursor: wait;
}

.disabled\\:border-\\[\\#80aa91\\]:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(128 170 145 / var(--tw-border-opacity, 1));
}

.disabled\\:border-\\[\\#e2e7e3\\]:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(226 231 227 / var(--tw-border-opacity, 1));
}

.disabled\\:border-hajj-primary:disabled {
  border-color: var(--hajj-primary);
}

.disabled\\:bg-\\[\\#80aa91\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(128 170 145 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-\\[\\#f1f3f2\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(241 243 242 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-\\[\\#f7f9f7\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(247 249 247 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-hajj-primary:disabled {
  background-color: var(--hajj-primary);
}

.disabled\\:text-\\[\\#6f7b73\\]:disabled {
  --tw-text-opacity: 1;
  color: rgb(111 123 115 / var(--tw-text-opacity, 1));
}

.disabled\\:text-\\[\\#7b867f\\]:disabled {
  --tw-text-opacity: 1;
  color: rgb(123 134 127 / var(--tw-text-opacity, 1));
}

.disabled\\:text-white:disabled {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.disabled\\:opacity-100:disabled {
  opacity: 1;
}

.disabled\\:opacity-35:disabled {
  opacity: 0.35;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group[open] .group-open\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/menu-item:focus-within .group-focus-within\\/menu-item\\:opacity-100 {
  opacity: 1;
}

.group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100 {
  opacity: 1;
}

.peer\\/menu-button:hover ~ .peer-hover\\/menu-button\\:text-sidebar-accent-foreground {
  color: var(--sidebar-accent-foreground);
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}

.has-\\[\\>\\[data-slot\\=button-group\\]\\]\\:gap-2:has(>[data-slot=button-group]) {
  gap: 0.5rem;
}

.has-\\[\\[data-variant\\=inset\\]\\]\\:bg-sidebar:has([data-variant=inset]) {
  background-color: var(--sidebar-background);
}

.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled) {
  opacity: 0.5;
}

.group\\/item:has([data-slot=item-description]) .group-has-\\[\\[data-slot\\=item-description\\]\\]\\/item\\:translate-y-0\\.5 {
  --tw-translate-y: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/item:has([data-slot=item-description]) .group-has-\\[\\[data-slot\\=item-description\\]\\]\\/item\\:self-start {
  align-self: flex-start;
}

.group\\/menu-item:has([data-sidebar=menu-action]) .group-has-\\[\\[data-sidebar\\=menu-action\\]\\]\\/menu-item\\:pr-8 {
  padding-right: 2rem;
}

.aria-disabled\\:pointer-events-none[aria-disabled="true"] {
  pointer-events: none;
}

.aria-disabled\\:opacity-50[aria-disabled="true"] {
  opacity: 0.5;
}

.aria-expanded\\:font-semibold[aria-expanded="true"] {
  font-weight: 600;
}

.aria-expanded\\:text-\\[\\#2a7245\\][aria-expanded="true"] {
  --tw-text-opacity: 1;
  color: rgb(42 114 69 / var(--tw-text-opacity, 1));
}

.aria-selected\\:border-hajj-primary[aria-selected="true"] {
  border-color: var(--hajj-primary);
}

.aria-selected\\:bg-hajj-primary[aria-selected="true"] {
  background-color: var(--hajj-primary);
}

.aria-selected\\:text-muted-foreground[aria-selected="true"] {
  color: var(--muted-foreground);
}

.aria-selected\\:text-white[aria-selected="true"] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.aria-selected\\:hover\\:bg-\\[\\#216341\\]:hover[aria-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(33 99 65 / var(--tw-bg-opacity, 1));
}

.aria-\\[invalid\\=true\\]\\:border-\\[\\#c77b74\\][aria-invalid="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(199 123 116 / var(--tw-border-opacity, 1));
}

.aria-\\[invalid\\=true\\]\\:focus-visible\\:border-\\[\\#c77b74\\]:focus-visible[aria-invalid="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(199 123 116 / var(--tw-border-opacity, 1));
}

.aria-\\[invalid\\=true\\]\\:focus-visible\\:ring-\\[rgba\\(168\\2c 62\\2c 62\\2c 0\\.08\\)\\]:focus-visible[aria-invalid="true"] {
  --tw-ring-color: rgba(168,62,62,0.08);
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}

.data-\\[dragging\\=true\\]\\:z-10[data-dragging="true"] {
  z-index: 10;
}

.data-\\[orientation\\=horizontal\\]\\:h-px[data-orientation="horizontal"] {
  height: 1px;
}

.data-\\[orientation\\=vertical\\]\\:h-auto[data-orientation="vertical"] {
  height: auto;
}

.data-\\[orientation\\=vertical\\]\\:h-full[data-orientation="vertical"] {
  height: 100%;
}

.data-\\[orientation\\=horizontal\\]\\:w-full[data-orientation="horizontal"] {
  width: 100%;
}

.data-\\[orientation\\=vertical\\]\\:w-px[data-orientation="vertical"] {
  width: 1px;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"] {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"] {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"] {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"] {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-5[data-state="checked"] {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[selected\\=true\\]\\:rounded-none[data-selected="true"] {
  border-radius: 0px;
}

.data-\\[active\\=true\\]\\:border-\\[\\#287c50\\][data-active="true"] {
  --tw-border-opacity: 1;
  border-color: rgb(40 124 80 / var(--tw-border-opacity, 1));
}

.data-\\[state\\=checked\\]\\:border-hajj-primary[data-state="checked"] {
  border-color: var(--hajj-primary);
}

.data-\\[state\\=open\\]\\:border-\\[\\#81ab91\\][data-state="open"] {
  --tw-border-opacity: 1;
  border-color: rgb(129 171 145 / var(--tw-border-opacity, 1));
}

.data-\\[state\\=open\\]\\:border-\\[\\#86ae93\\][data-state="open"] {
  --tw-border-opacity: 1;
  border-color: rgb(134 174 147 / var(--tw-border-opacity, 1));
}

.data-\\[active\\=true\\]\\:bg-sidebar-accent[data-active="true"] {
  background-color: var(--sidebar-accent);
}

.data-\\[range-end\\=true\\]\\:bg-primary[data-range-end="true"] {
  background-color: var(--primary);
}

.data-\\[range-middle\\=true\\]\\:bg-accent[data-range-middle="true"] {
  background-color: var(--accent);
}

.data-\\[range-start\\=true\\]\\:bg-primary[data-range-start="true"] {
  background-color: var(--primary);
}

.data-\\[selected-single\\=true\\]\\:bg-primary[data-selected-single="true"] {
  background-color: var(--primary);
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
  background-color: var(--background);
}

.data-\\[state\\=checked\\]\\:bg-\\[\\#eaf3ed\\][data-state="checked"] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 243 237 / var(--tw-bg-opacity, 1));
}

.data-\\[state\\=checked\\]\\:bg-hajj-primary[data-state="checked"] {
  background-color: var(--hajj-primary);
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
  background-color: var(--primary);
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"] {
  background-color: var(--accent);
}

.data-\\[state\\=open\\]\\:bg-\\[\\#e7f0e9\\][data-state="open"] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 240 233 / var(--tw-bg-opacity, 1));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
  background-color: var(--accent);
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"] {
  background-color: var(--secondary);
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"] {
  background-color: var(--muted);
}

.data-\\[state\\=unchecked\\]\\:bg-hajj-muted[data-state="unchecked"] {
  background-color: var(--hajj-muted);
}

.data-\\[active\\=true\\]\\:font-medium[data-active="true"] {
  font-weight: 500;
}

.data-\\[state\\=checked\\]\\:font-semibold[data-state="checked"] {
  font-weight: 600;
}

.data-\\[active\\=true\\]\\:text-sidebar-accent-foreground[data-active="true"] {
  color: var(--sidebar-accent-foreground);
}

.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder] {
  color: var(--muted-foreground);
}

.data-\\[range-end\\=true\\]\\:text-primary-foreground[data-range-end="true"] {
  color: var(--primary-foreground);
}

.data-\\[range-middle\\=true\\]\\:text-accent-foreground[data-range-middle="true"] {
  color: var(--accent-foreground);
}

.data-\\[range-start\\=true\\]\\:text-primary-foreground[data-range-start="true"] {
  color: var(--primary-foreground);
}

.data-\\[selected-single\\=true\\]\\:text-primary-foreground[data-selected-single="true"] {
  color: var(--primary-foreground);
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"] {
  color: var(--foreground);
}

.data-\\[state\\=checked\\]\\:text-\\[\\#235c3b\\][data-state="checked"] {
  --tw-text-opacity: 1;
  color: rgb(35 92 59 / var(--tw-text-opacity, 1));
}

.data-\\[state\\=checked\\]\\:text-hajj-primary[data-state="checked"] {
  color: var(--hajj-primary);
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
  color: var(--primary-foreground);
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"] {
  color: var(--accent-foreground);
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"] {
  color: var(--muted-foreground);
}

.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}

.data-\\[dragging\\=true\\]\\:opacity-80[data-dragging="true"] {
  opacity: 0.8;
}

.data-\\[state\\=open\\]\\:opacity-100[data-state="open"] {
  opacity: 1;
}

.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[active\\=true\\]\\:ring-\\[3px\\][data-active="true"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\\[state\\=open\\]\\:ring-2[data-state="open"] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.data-\\[active\\=true\\]\\:ring-\\[\\#287c50\\]\\/\\[0\\.08\\][data-active="true"] {
  --tw-ring-color: rgb(40 124 80 / 0.08);
}

.data-\\[state\\=open\\]\\:ring-\\[rgba\\(43\\2c 123\\2c 83\\2c 0\\.10\\)\\][data-state="open"] {
  --tw-ring-color: rgba(43,123,83,0.10);
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  transition-duration: 500ms;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
  --tw-exit-opacity: 0;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
  --tw-enter-scale: .95;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"] {
  --tw-exit-translate-y: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
  --tw-exit-translate-x: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"] {
  --tw-exit-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"] {
  --tw-enter-translate-y: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
  --tw-enter-translate-x: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
  --tw-enter-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"] {
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  animation-duration: 500ms;
}

.data-\\[state\\=open\\]\\:hover\\:bg-sidebar-accent:hover[data-state="open"] {
  background-color: var(--sidebar-accent);
}

.data-\\[state\\=open\\]\\:hover\\:text-sidebar-accent-foreground:hover[data-state="open"] {
  color: var(--sidebar-accent-foreground);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:left-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\] {
  left: calc(var(--sidebar-width) * -1);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:right-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\] {
  right: calc(var(--sidebar-width) * -1);
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:-right-4 {
  right: -1rem;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:left-0 {
  left: 0px;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:-mt-8 {
  margin-top: -2rem;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:hidden {
  display: none;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!size-8 {
  width: 2rem !important;
  height: 2rem !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[--sidebar-width-icon\\] {
  width: var(--sidebar-width-icon);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)\\)\\] {
  width: calc(var(--sidebar-width-icon) + 1rem);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)_\\+2px\\)\\] {
  width: calc(var(--sidebar-width-icon) + 1rem + 2px);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:w-0 {
  width: 0px;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:overflow-hidden {
  overflow: hidden;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:rounded-lg {
  border-radius: var(--radius);
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border {
  border-width: 1px;
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:border-r {
  border-right-width: 1px;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:border-l {
  border-left-width: 1px;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border-sidebar-border {
  border-color: var(--sidebar-border);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!p-0 {
  padding: 0px !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!p-2 {
  padding: 0.5rem !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:opacity-0 {
  opacity: 0;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group\\/day[data-focused="true"] .group-data-\\[focused\\=true\\]\\/day\\:ring-\\[3px\\] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:after\\:left-full::after {
  content: var(--tw-content);
  left: 100%;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:hover\\:bg-sidebar:hover {
  background-color: var(--sidebar-background);
}

.peer\\/menu-button[data-size="default"] ~ .peer-data-\\[size\\=default\\]\\/menu-button\\:top-1\\.5 {
  top: 0.375rem;
}

.peer\\/menu-button[data-size="lg"] ~ .peer-data-\\[size\\=lg\\]\\/menu-button\\:top-2\\.5 {
  top: 0.625rem;
}

.peer\\/menu-button[data-size="sm"] ~ .peer-data-\\[size\\=sm\\]\\/menu-button\\:top-1 {
  top: 0.25rem;
}

.peer\\/menu-button[data-active="true"] ~ .peer-data-\\[active\\=true\\]\\/menu-button\\:text-sidebar-accent-foreground {
  color: var(--sidebar-accent-foreground);
}

.dark\\:border-destructive:is(.dark *) {
  border-color: var(--destructive);
}

@media (max-width: 700px) {

  .max-\\[700px\\]\\:sticky {
    position: sticky;
  }

  .max-\\[700px\\]\\:right-0 {
    right: 0px;
  }

  .max-\\[700px\\]\\:z-10 {
    z-index: 10;
  }

  .max-\\[700px\\]\\:z-\\[5\\] {
    z-index: 5;
  }

  .max-\\[700px\\]\\:hidden {
    display: none;
  }

  .max-\\[700px\\]\\:flex-1 {
    flex: 1 1;
  }

  .max-\\[700px\\]\\:gap-2 {
    gap: 0.5rem;
  }

  .max-\\[700px\\]\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .max-\\[700px\\]\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .max-\\[700px\\]\\:shadow-\\[-5px_0_8px_-7px_rgba\\(30\\2c 53\\2c 37\\2c 0\\.35\\)\\] {
    --tw-shadow: -5px 0 8px -7px rgba(30,53,37,0.35);
    --tw-shadow-colored: -5px 0 8px -7px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media not all and (min-width: 640px) {

  .max-sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .max-sm\\:grid {
    display: grid;
  }

  .max-sm\\:max-h-\\[calc\\(100dvh-54px\\)\\] {
    max-height: calc(100dvh - 54px);
  }

  .max-sm\\:max-w-full {
    max-width: 100%;
  }

  .max-sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .max-sm\\:grid-cols-\\[65px_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 65px minmax(0,1fr);
  }

  .max-sm\\:gap-1\\.5 {
    gap: 0.375rem;
  }

  .max-sm\\:gap-3\\.5 {
    gap: 0.875rem;
  }

  .max-sm\\:gap-y-2\\.5 {
    row-gap: 0.625rem;
  }

  .max-sm\\:rounded-b-none {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  .max-sm\\:px-\\[18px\\] {
    padding-left: 18px;
    padding-right: 18px;
  }

  .max-sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .max-sm\\:pb-4 {
    padding-bottom: 1rem;
  }

  .max-sm\\:pb-\\[22px\\] {
    padding-bottom: 22px;
  }

  .max-sm\\:pr-\\[54px\\] {
    padding-right: 54px;
  }

  .max-sm\\:pt-0\\.5 {
    padding-top: 0.125rem;
  }

  .max-sm\\:pt-\\[18px\\] {
    padding-top: 18px;
  }

  .max-sm\\:pt-\\[19px\\] {
    padding-top: 19px;
  }

  .max-sm\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .max-sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

@media (max-width: 520px) {

  .max-\\[520px\\]\\:mx-2\\.5 {
    margin-left: 0.625rem;
    margin-right: 0.625rem;
  }

  .max-\\[520px\\]\\:mb-7 {
    margin-bottom: 1.75rem;
  }

  .max-\\[520px\\]\\:h-\\[46px\\] {
    height: 46px;
  }

  .max-\\[520px\\]\\:w-\\[37px\\] {
    width: 37px;
  }

  .max-\\[520px\\]\\:gap-5 {
    gap: 1.25rem;
  }

  .max-\\[520px\\]\\:p-4 {
    padding: 1rem;
  }

  .max-\\[520px\\]\\:p-\\[22px\\] {
    padding: 22px;
  }

  .max-\\[520px\\]\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .max-\\[520px\\]\\:py-9 {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .max-\\[520px\\]\\:pr-0 {
    padding-right: 0px;
  }

  .max-\\[520px\\]\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .max-\\[520px\\]\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .max-\\[520px\\]\\:text-\\[27px\\] {
    font-size: 27px;
  }
}

@media (max-width: 420px) {

  .max-\\[420px\\]\\:hidden {
    display: none;
  }
}

@media (max-width: 380px) {

  .max-\\[380px\\]\\:order-first {
    order: -9999;
  }

  .max-\\[380px\\]\\:h-11 {
    height: 2.75rem;
  }

  .max-\\[380px\\]\\:w-\\[35px\\] {
    width: 35px;
  }

  .max-\\[380px\\]\\:w-full {
    width: 100%;
  }

  .max-\\[380px\\]\\:flex-none {
    flex: none;
  }

  .max-\\[380px\\]\\:flex-col {
    flex-direction: column;
  }

  .max-\\[380px\\]\\:gap-1\\.5 {
    gap: 0.375rem;
  }

  .max-\\[380px\\]\\:gap-\\[15px\\] {
    gap: 15px;
  }

  .max-\\[380px\\]\\:gap-\\[5px\\] {
    gap: 5px;
  }
}

@media (max-width: 375px) {

  .max-\\[375px\\]\\:p-4 {
    padding: 1rem;
  }

  .max-\\[375px\\]\\:p-\\[7px\\] {
    padding: 7px;
  }

  .max-\\[375px\\]\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 421px) {

  .min-\\[421px\\]\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .min-\\[421px\\]\\:gap-4 {
    gap: 1rem;
  }
}

@media (min-width: 521px) {

  .min-\\[521px\\]\\:top-7 {
    top: 1.75rem;
  }

  .min-\\[521px\\]\\:h-\\[94px\\] {
    height: 94px;
  }

  .min-\\[521px\\]\\:min-h-\\[calc\\(100dvh-94px\\)\\] {
    min-height: calc(100dvh - 94px);
  }
}

@media (min-width: 640px) {

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .sm\\:mb-\\[26px\\] {
    margin-bottom: 26px;
  }

  .sm\\:ml-auto {
    margin-left: auto;
  }

  .sm\\:mr-auto {
    margin-right: auto;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:table {
    display: table;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-\\[34px\\] {
    height: 34px;
  }

  .sm\\:max-h-\\[calc\\(100dvh-2\\.5rem\\)\\] {
    max-height: calc(100dvh - 2.5rem);
  }

  .sm\\:max-h-\\[calc\\(100dvh-2rem\\)\\] {
    max-height: calc(100dvh - 2rem);
  }

  .sm\\:max-h-\\[calc\\(100dvh-3rem\\)\\] {
    max-height: calc(100dvh - 3rem);
  }

  .sm\\:\\!w-\\[calc\\(100\\%_-_60px\\)\\] {
    width: calc(100% - 60px) !important;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:min-w-\\[246px\\] {
    min-width: 246px;
  }

  .sm\\:max-w-\\[360px\\] {
    max-width: 360px;
  }

  .sm\\:max-w-\\[480px\\] {
    max-width: 480px;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:flex-1 {
    flex: 1 1;
  }

  .sm\\:flex-none {
    flex: none;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[150px_minmax\\(0\\2c 1fr\\)_190px\\] {
    grid-template-columns: 150px minmax(0,1fr) 190px;
  }

  .sm\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_190px\\] {
    grid-template-columns: minmax(0,1fr) 190px;
  }

  .sm\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto\\] {
    grid-template-columns: minmax(0,1fr) auto;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-\\[30px\\] {
    gap: 30px;
  }

  .sm\\:gap-x-6 {
    column-gap: 1.5rem;
  }

  .sm\\:space-x-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0px * var(--tw-space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:self-center {
    align-self: center;
  }

  .sm\\:rounded-\\[10px\\] {
    border-radius: 10px;
  }

  .sm\\:rounded-\\[14px\\] {
    border-radius: 14px;
  }

  .sm\\:rounded-lg {
    border-radius: var(--radius);
  }

  .sm\\:border-r {
    border-right-width: 1px;
  }

  .sm\\:border-t-0 {
    border-top-width: 0px;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-\\[22px\\] {
    padding: 22px;
  }

  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:px-\\[26px\\] {
    padding-left: 26px;
    padding-right: 26px;
  }

  .sm\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }

  .sm\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:py-\\[19px\\] {
    padding-top: 19px;
    padding-bottom: 19px;
  }

  .sm\\:pb-2\\.5 {
    padding-bottom: 0.625rem;
  }

  .sm\\:pt-0 {
    padding-top: 0px;
  }

  .sm\\:pt-5 {
    padding-top: 1.25rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-right {
    text-align: right;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:leading-5 {
    line-height: 1.25rem;
  }

  .sm\\:leading-\\[31px\\] {
    line-height: 31px;
  }

  .sm\\:tracking-\\[-0\\.55px\\] {
    letter-spacing: -0.55px;
  }
}

@media (min-width: 651px) {

  .min-\\[651px\\]\\:right-6 {
    right: 1.5rem;
  }

  .min-\\[651px\\]\\:top-6 {
    top: 1.5rem;
  }

  .min-\\[651px\\]\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .min-\\[651px\\]\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .min-\\[651px\\]\\:pr-16 {
    padding-right: 4rem;
  }

  .min-\\[651px\\]\\:pt-6 {
    padding-top: 1.5rem;
  }

  .min-\\[651px\\]\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 681px) {

  .min-\\[681px\\]\\:col-auto {
    grid-column: auto;
  }

  .min-\\[681px\\]\\:my-\\[30px\\] {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .min-\\[681px\\]\\:mb-\\[18px\\] {
    margin-bottom: 18px;
  }

  .min-\\[681px\\]\\:grid {
    display: grid;
  }

  .min-\\[681px\\]\\:size-\\[34px\\] {
    width: 34px;
    height: 34px;
  }

  .min-\\[681px\\]\\:h-\\[370px\\] {
    height: 370px;
  }

  .min-\\[681px\\]\\:min-h-\\[110px\\] {
    min-height: 110px;
  }

  .min-\\[681px\\]\\:min-h-\\[500px\\] {
    min-height: 500px;
  }

  .min-\\[681px\\]\\:w-\\[180px\\] {
    width: 180px;
  }

  .min-\\[681px\\]\\:w-\\[calc\\(100\\%-56px\\)\\] {
    width: calc(100% - 56px);
  }

  .min-\\[681px\\]\\:w-\\[calc\\(100\\%-80px\\)\\] {
    width: calc(100% - 80px);
  }

  .min-\\[681px\\]\\:max-w-\\[950px\\] {
    max-width: 950px;
  }

  .min-\\[681px\\]\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .min-\\[681px\\]\\:grid-cols-\\[0\\.8fr_1\\.5fr\\] {
    grid-template-columns: 0.8fr 1.5fr;
  }

  .min-\\[681px\\]\\:grid-cols-\\[1\\.7fr_1fr_1\\.2fr\\] {
    grid-template-columns: 1.7fr 1fr 1.2fr;
  }

  .min-\\[681px\\]\\:grid-cols-\\[1fr_auto_1fr\\] {
    grid-template-columns: 1fr auto 1fr;
  }

  .min-\\[681px\\]\\:grid-cols-\\[auto_1fr\\] {
    grid-template-columns: auto 1fr;
  }

  .min-\\[681px\\]\\:justify-end {
    justify-content: flex-end;
  }

  .min-\\[681px\\]\\:gap-5 {
    gap: 1.25rem;
  }

  .min-\\[681px\\]\\:gap-6 {
    gap: 1.5rem;
  }

  .min-\\[681px\\]\\:gap-\\[30px\\] {
    gap: 30px;
  }

  .min-\\[681px\\]\\:gap-x-2\\.5 {
    column-gap: 0.625rem;
  }

  .min-\\[681px\\]\\:gap-y-0 {
    row-gap: 0px;
  }

  .min-\\[681px\\]\\:p-6 {
    padding: 1.5rem;
  }

  .min-\\[681px\\]\\:p-\\[18px\\] {
    padding: 18px;
  }

  .min-\\[681px\\]\\:p-\\[7px\\] {
    padding: 7px;
  }

  .min-\\[681px\\]\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .min-\\[681px\\]\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .min-\\[681px\\]\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .min-\\[681px\\]\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .min-\\[681px\\]\\:py-\\[10px\\] {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .min-\\[681px\\]\\:py-\\[66px\\] {
    padding-top: 66px;
    padding-bottom: 66px;
  }

  .min-\\[681px\\]\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .min-\\[681px\\]\\:pt-16 {
    padding-top: 4rem;
  }

  .min-\\[681px\\]\\:text-left {
    text-align: left;
  }

  .min-\\[681px\\]\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .min-\\[681px\\]\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .min-\\[681px\\]\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .min-\\[681px\\]\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .min-\\[681px\\]\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .min-\\[681px\\]\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .min-\\[681px\\]\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .min-\\[681px\\]\\:leading-\\[1\\.18\\] {
    line-height: 1.18;
  }

  .min-\\[681px\\]\\:leading-\\[1\\.75\\] {
    line-height: 1.75;
  }
}

@media (min-width: 768px) {

  .md\\:top-0 {
    top: 0px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[225px_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 225px minmax(0,1fr);
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:p-12 {
    padding: 3rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:opacity-0 {
    opacity: 0;
  }

  .after\\:md\\:hidden::after {
    content: var(--tw-content);
    display: none;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:m-2 {
    margin: 0.5rem;
  }

  .peer[data-state="collapsed"][data-variant="inset"] ~ .md\\:peer-data-\\[state\\=collapsed\\]\\:peer-data-\\[variant\\=inset\\]\\:ml-2 {
    margin-left: 0.5rem;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:ml-0 {
    margin-left: 0px;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 1001px) {

  .min-\\[1001px\\]\\:block {
    display: block;
  }

  .min-\\[1001px\\]\\:h-\\[17\\.9cqw\\] {
    height: 17.9cqw;
  }

  .min-\\[1001px\\]\\:h-\\[385px\\] {
    height: 385px;
  }

  .min-\\[1001px\\]\\:min-h-\\[620px\\] {
    min-height: 620px;
  }

  .min-\\[1001px\\]\\:w-\\[210px\\] {
    width: 210px;
  }

  .min-\\[1001px\\]\\:w-\\[calc\\(100\\%-112px\\)\\] {
    width: calc(100% - 112px);
  }

  .min-\\[1001px\\]\\:grid-cols-\\[2fr_20fr_5fr_20fr_7fr_20fr_5fr_20fr_1fr\\] {
    grid-template-columns: 2fr 20fr 5fr 20fr 7fr 20fr 5fr 20fr 1fr;
  }

  .min-\\[1001px\\]\\:gap-0 {
    gap: 0px;
  }

  .min-\\[1001px\\]\\:gap-10 {
    gap: 2.5rem;
  }

  .min-\\[1001px\\]\\:gap-\\[25px\\] {
    gap: 25px;
  }

  .min-\\[1001px\\]\\:gap-\\[58px\\] {
    gap: 58px;
  }

  .min-\\[1001px\\]\\:gap-\\[70px\\] {
    gap: 70px;
  }

  .min-\\[1001px\\]\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .min-\\[1001px\\]\\:py-\\[30px\\] {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .min-\\[1001px\\]\\:pt-0 {
    padding-top: 0px;
  }

  .min-\\[1001px\\]\\:first\\:col-start-2:first-child {
    grid-column-start: 2;
  }

  .min-\\[1001px\\]\\:first\\:mt-\\[6\\.5cqw\\]:first-child {
    margin-top: 6.5cqw;
  }

  .min-\\[1001px\\]\\:last\\:col-start-8:last-child {
    grid-column-start: 8;
  }

  .min-\\[1001px\\]\\:last\\:mt-\\[15\\.45cqw\\]:last-child {
    margin-top: 15.45cqw;
  }
}

@media (min-width: 1024px) {

  .lg\\:static {
    position: static;
  }

  .lg\\:fixed {
    position: fixed;
  }

  .lg\\:inset-y-0 {
    top: 0px;
    bottom: 0px;
  }

  .lg\\:left-0 {
    left: 0px;
  }

  .lg\\:order-none {
    order: 0;
  }

  .lg\\:ml-\\[224px\\] {
    margin-left: 224px;
  }

  .lg\\:ml-\\[min\\(27vw\\2c 450px\\)\\] {
    margin-left: min(27vw,450px);
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:table-cell {
    display: table-cell;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-\\[500px\\] {
    height: 500px;
  }

  .lg\\:h-\\[80vh\\] {
    height: 80vh;
  }

  .lg\\:h-dvh {
    height: 100dvh;
  }

  .lg\\:min-h-screen {
    min-height: 100vh;
  }

  .lg\\:w-24 {
    width: 6rem;
  }

  .lg\\:w-\\[224px\\] {
    width: 224px;
  }

  .lg\\:w-\\[315px\\] {
    width: 315px;
  }

  .lg\\:w-\\[400px\\] {
    width: 400px;
  }

  .lg\\:w-\\[min\\(27vw\\2c 450px\\)\\] {
    width: min(27vw,450px);
  }

  .lg\\:min-w-0 {
    min-width: 0px;
  }

  .lg\\:max-w-\\[450px\\] {
    max-width: 450px;
  }

  .lg\\:max-w-xl {
    max-width: 36rem;
  }

  .lg\\:-translate-y-6 {
    --tw-translate-y: -1.5rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[2fr_3fr\\] {
    grid-template-columns: 2fr 3fr;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-\\[16\\%\\] {
    padding-left: 16%;
    padding-right: 16%;
  }

  .lg\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .lg\\:py-\\[30px\\] {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .lg\\:pr-0 {
    padding-right: 0px;
  }

  .lg\\:pt-0 {
    padding-top: 0px;
  }

  .lg\\:opacity-100 {
    opacity: 1;
  }

  .lg\\:last\\:border-r-0:last-child {
    border-right-width: 0px;
  }
}

@media (min-width: 1280px) {

  .xl\\:max-w-\\[1320px\\] {
    max-width: 1320px;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[1fr_1\\.3fr_1\\.3fr\\] {
    grid-template-columns: 1fr 1.3fr 1.3fr;
  }

  .xl\\:gap-x-4 {
    column-gap: 1rem;
  }

  .xl\\:p-\\[22px\\] {
    padding: 22px;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:max-w-\\[500px\\] {
    max-width: 500px;
  }
}

.\\[\\&\\+\\[data-slot\\=item-content\\]\\]\\:flex-none+[data-slot=item-content] {
  flex: none;
}

.\\[\\&\\:\\:-webkit-details-marker\\]\\:hidden::-webkit-details-marker {
  display: none;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded::-webkit-scrollbar-thumb {
  border-radius: 0.25rem;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-\\[\\#e6ebe7\\]::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(230 235 231 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-transparent::-webkit-scrollbar-track {
  background-color: transparent;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-1::-webkit-scrollbar {
  width: 0.25rem;
}

.\\[\\&\\:first-child\\[data-selected\\=true\\]_button\\]\\:rounded-l-md:first-child[data-selected=true] button {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:focus-within\\:\\:-webkit-scrollbar-thumb\\]\\:bg-\\[\\#c9d3cc\\]:focus-within::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(201 211 204 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
  padding-right: 0px;
}

.\\[\\&\\:hover\\:\\:-webkit-scrollbar-thumb\\]\\:bg-\\[\\#c9d3cc\\]:hover::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(201 211 204 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:last-child\\[data-selected\\=true\\]_button\\]\\:rounded-r-md:last-child[data-selected=true] button {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

@media (min-width: 1001px) {

  .min-\\[1001px\\]\\:\\[\\&\\:nth-child\\(2\\)\\]\\:col-start-4:nth-child(2) {
    grid-column-start: 4;
  }

  .min-\\[1001px\\]\\:\\[\\&\\:nth-child\\(2\\)\\]\\:mt-\\[15\\.45cqw\\]:nth-child(2) {
    margin-top: 15.45cqw;
  }
}

@media (min-width: 640px) {

  .sm\\:\\[\\&\\:nth-child\\(2n\\)\\]\\:border-r-0:nth-child(2n) {
    border-right-width: 0px;
  }
}

@media (min-width: 1024px) {

  .lg\\:\\[\\&\\:nth-child\\(2n\\)\\]\\:border-r:nth-child(2n) {
    border-right-width: 1px;
  }
}

@media (min-width: 1001px) {

  .min-\\[1001px\\]\\:\\[\\&\\:nth-child\\(3\\)\\]\\:col-start-6:nth-child(3) {
    grid-column-start: 6;
  }

  .min-\\[1001px\\]\\:\\[\\&\\:nth-child\\(3\\)\\]\\:mt-\\[10\\.15cqw\\]:nth-child(3) {
    margin-top: 10.15cqw;
  }
}

.\\[\\&\\>\\*\\:not\\(\\:first-child\\)\\]\\:rounded-l-none>*:not(:first-child) {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.\\[\\&\\>\\*\\:not\\(\\:first-child\\)\\]\\:rounded-t-none>*:not(:first-child) {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.\\[\\&\\>\\*\\:not\\(\\:first-child\\)\\]\\:border-l-0>*:not(:first-child) {
  border-left-width: 0px;
}

.\\[\\&\\>\\*\\:not\\(\\:first-child\\)\\]\\:border-t-0>*:not(:first-child) {
  border-top-width: 0px;
}

.\\[\\&\\>\\*\\:not\\(\\:last-child\\)\\]\\:rounded-b-none>*:not(:last-child) {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.\\[\\&\\>\\*\\:not\\(\\:last-child\\)\\]\\:rounded-r-none>*:not(:last-child) {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.\\[\\&\\>\\*\\]\\:focus-visible\\:relative:focus-visible>* {
  position: relative;
}

.\\[\\&\\>\\*\\]\\:focus-visible\\:z-10:focus-visible>* {
  z-index: 10;
}

.has-\\[select\\[aria-hidden\\=true\\]\\:last-child\\]\\:\\[\\&\\>\\[data-slot\\=select-trigger\\]\\:last-of-type\\]\\:rounded-r-md>[data-slot=select-trigger]:last-of-type:has(select[aria-hidden=true]:last-child) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\>\\[data-slot\\=select-trigger\\]\\:not\\(\\[class\\*\\=\\'w-\\'\\]\\)\\]\\:w-fit>[data-slot=select-trigger]:not([class*='w-']) {
  width: fit-content;
}

.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox] {
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>a\\:hover\\]\\:text-primary>a:hover {
  color: var(--primary);
}

.\\[\\&\\>a\\]\\:underline>a {
  text-decoration-line: underline;
}

.\\[\\&\\>a\\]\\:underline-offset-4>a {
  text-underline-offset: 4px;
}

.\\[\\&\\>button\\]\\:hidden>button {
  display: none;
}

.\\[\\&\\>div\\:empty\\]\\:hidden>div:empty {
  display: none;
}

.\\[\\&\\>div\\]\\:mt-2>div {
  margin-top: 0.5rem;
}

.\\[\\&\\>div\\]\\:flex>div {
  display: flex;
}

.\\[\\&\\>div\\]\\:justify-between>div {
  justify-content: space-between;
}

.\\[\\&\\>div\\]\\:gap-3>div {
  gap: 0.75rem;
}

.\\[\\&\\>input\\]\\:flex-1>input {
  flex: 1 1;
}

.\\[\\&\\>nav\\]\\:text-sm>nav {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.\\[\\&\\>p\\:first-child\\]\\:text-\\[13px\\]>p:first-child {
  font-size: 13px;
}

.\\[\\&\\>p\\:first-child\\]\\:text-\\[\\#586357\\]>p:first-child {
  --tw-text-opacity: 1;
  color: rgb(88 99 87 / var(--tw-text-opacity, 1));
}

.\\[\\&\\>p\\]\\:text-\\[\\#dce7df\\]>p {
  --tw-text-opacity: 1;
  color: rgb(220 231 223 / var(--tw-text-opacity, 1));
}

.\\[\\&\\>span\\:last-child\\]\\:flex>span:last-child {
  display: flex;
}

.\\[\\&\\>span\\:last-child\\]\\:w-full>span:last-child {
  width: 100%;
}

.\\[\\&\\>span\\:last-child\\]\\:truncate>span:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.\\[\\&\\>span\\]\\:mt-\\[5px\\]>span {
  margin-top: 5px;
}

.\\[\\&\\>span\\]\\:line-clamp-1>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>span\\]\\:block>span {
  display: block;
}

.\\[\\&\\>span\\]\\:text-xs>span {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&\\>span\\]\\:font-medium>span {
  font-weight: 500;
}

.\\[\\&\\>span\\]\\:text-\\[\\#47643c\\]>span {
  --tw-text-opacity: 1;
  color: rgb(71 100 60 / var(--tw-text-opacity, 1));
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div {
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>svg\\:last-child\\]\\:h-\\[13px\\]>svg:last-child {
  height: 13px;
}

.\\[\\&\\>svg\\:last-child\\]\\:w-\\[13px\\]>svg:last-child {
  width: 13px;
}

.\\[\\&\\>svg\\:last-child\\]\\:shrink-0>svg:last-child {
  flex-shrink: 0;
}

.\\[\\&\\>svg\\]\\:absolute>svg {
  position: absolute;
}

.\\[\\&\\>svg\\]\\:left-4>svg {
  left: 1rem;
}

.\\[\\&\\>svg\\]\\:top-4>svg {
  top: 1rem;
}

.\\[\\&\\>svg\\]\\:size-3\\.5>svg {
  width: 0.875rem;
  height: 0.875rem;
}

.\\[\\&\\>svg\\]\\:size-4>svg {
  width: 1rem;
  height: 1rem;
}

.\\[\\&\\>svg\\]\\:h-2\\.5>svg {
  height: 0.625rem;
}

.\\[\\&\\>svg\\]\\:h-3>svg {
  height: 0.75rem;
}

.\\[\\&\\>svg\\]\\:h-5>svg {
  height: 1.25rem;
}

.\\[\\&\\>svg\\]\\:w-2\\.5>svg {
  width: 0.625rem;
}

.\\[\\&\\>svg\\]\\:w-3>svg {
  width: 0.75rem;
}

.\\[\\&\\>svg\\]\\:w-5>svg {
  width: 1.25rem;
}

.\\[\\&\\>svg\\]\\:shrink-0>svg {
  flex-shrink: 0;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg {
  color: var(--destructive);
}

.\\[\\&\\>svg\\]\\:text-foreground>svg {
  color: var(--foreground);
}

.\\[\\&\\>svg\\]\\:text-muted-foreground>svg {
  color: var(--muted-foreground);
}

.\\[\\&\\>svg\\]\\:text-sidebar-accent-foreground>svg {
  color: var(--sidebar-accent-foreground);
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~* {
  padding-left: 1.75rem;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
  border-bottom-width: 0px;
}

.\\[\\&_\\.recharts-cartesian-axis-tick_text\\]\\:fill-muted-foreground .recharts-cartesian-axis-tick text {
  fill: var(--muted-foreground);
}

.\\[\\&_\\.recharts-curve\\.recharts-tooltip-cursor\\]\\:stroke-border .recharts-curve.recharts-tooltip-cursor {
  stroke: var(--border);
}

.\\[\\&_\\.recharts-dot\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-dot[stroke='#fff'] {
  stroke: transparent;
}

.\\[\\&_\\.recharts-layer\\]\\:outline-none .recharts-layer {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\.recharts-polar-grid_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-polar-grid [stroke='#ccc'] {
  stroke: var(--border);
}

.\\[\\&_\\.recharts-radial-bar-background-sector\\]\\:fill-muted .recharts-radial-bar-background-sector {
  fill: var(--muted);
}

.\\[\\&_\\.recharts-rectangle\\.recharts-tooltip-cursor\\]\\:fill-muted .recharts-rectangle.recharts-tooltip-cursor {
  fill: var(--muted);
}

.\\[\\&_\\.recharts-reference-line_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-reference-line [stroke='#ccc'] {
  stroke: var(--border);
}

.\\[\\&_\\.recharts-sector\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-sector[stroke='#fff'] {
  stroke: transparent;
}

.\\[\\&_\\.recharts-sector\\]\\:outline-none .recharts-sector {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\.recharts-surface\\]\\:outline-none .recharts-surface {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\[data-otp-slot\\]\\]\\:border-destructive [data-otp-slot] {
  border-color: var(--destructive);
}

.\\[\\&_\\[data-radix-select-viewport\\]\\]\\:\\!h-auto [data-radix-select-viewport] {
  height: auto !important;
}

.\\[\\&_a\\:focus-visible\\]\\:outline a:focus-visible {
  outline-style: solid;
}

.\\[\\&_a\\:focus-visible\\]\\:outline-\\[3px\\] a:focus-visible {
  outline-width: 3px;
}

.\\[\\&_a\\:focus-visible\\]\\:outline-offset-\\[5px\\] a:focus-visible {
  outline-offset: 5px;
}

.\\[\\&_a\\:focus-visible\\]\\:outline-\\[\\#9abf70\\] a:focus-visible {
  outline-color: #9abf70;
}

.\\[\\&_a\\:hover\\]\\:underline a:hover {
  text-decoration-line: underline;
}

.\\[\\&_a\\]\\:mt-2\\.5 a {
  margin-top: 0.625rem;
}

.\\[\\&_a\\]\\:block a {
  display: block;
}

.\\[\\&_button\\]\\:text-sm button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.\\[\\&_dd\\]\\:font-semibold dd {
  font-weight: 600;
}

.\\[\\&_dt\\]\\:flex dt {
  display: flex;
}

.\\[\\&_dt\\]\\:items-center dt {
  align-items: center;
}

.\\[\\&_dt\\]\\:gap-2 dt {
  gap: 0.5rem;
}

.\\[\\&_h2\\]\\:mx-auto h2 {
  margin-left: auto;
  margin-right: auto;
}

.\\[\\&_h2\\]\\:mb-\\[18px\\] h2 {
  margin-bottom: 18px;
}

.\\[\\&_h2\\]\\:max-w-\\[850px\\] h2 {
  max-width: 850px;
}

.\\[\\&_h2\\]\\:text-center h2 {
  text-align: center;
}

.\\[\\&_h3\\]\\:mt-\\[3px\\] h3 {
  margin-top: 3px;
}

.\\[\\&_h3\\]\\:text-\\[22px\\] h3 {
  font-size: 22px;
}

.\\[\\&_h3\\]\\:text-\\[\\#00472f\\] h3 {
  --tw-text-opacity: 1;
  color: rgb(0 71 47 / var(--tw-text-opacity, 1));
}

.\\[\\&_img\\]\\:size-full img {
  width: 100%;
  height: 100%;
}

.\\[\\&_img\\]\\:object-cover img {
  object-fit: cover;
}

.\\[\\&_li\\]\\:flex li {
  display: flex;
}

.\\[\\&_li\\]\\:items-start li {
  align-items: flex-start;
}

.\\[\\&_li\\]\\:gap-\\[9px\\] li {
  gap: 9px;
}

.\\[\\&_p\\]\\:mb-3 p {
  margin-bottom: 0.75rem;
}

.\\[\\&_p\\]\\:leading-relaxed p {
  line-height: 1.625;
}

.\\[\\&_section\\[id\\]\\]\\:scroll-mt-\\[100px\\] section[id] {
  scroll-margin-top: 100px;
}

.\\[\\&_span\\]\\:text-xs span {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_strong\\]\\:mt-1 strong {
  margin-top: 0.25rem;
}

.\\[\\&_strong\\]\\:block strong {
  display: block;
}

.\\[\\&_strong\\]\\:text-\\[26px\\] strong {
  font-size: 26px;
}

.\\[\\&_strong\\]\\:text-\\[28px\\] strong {
  font-size: 28px;
}

.\\[\\&_strong\\]\\:font-semibold strong {
  font-weight: 600;
}

.\\[\\&_strong\\]\\:leading-\\[1\\.5\\] strong {
  line-height: 1.5;
}

.\\[\\&_strong\\]\\:text-\\[\\#00472f\\] strong {
  --tw-text-opacity: 1;
  color: rgb(0 71 47 / var(--tw-text-opacity, 1));
}

.\\[\\&_strong\\]\\:text-\\[\\#304f3b\\] strong {
  --tw-text-opacity: 1;
  color: rgb(48 79 59 / var(--tw-text-opacity, 1));
}

.\\[\\&_strong\\]\\:text-\\[\\#31502e\\] strong {
  --tw-text-opacity: 1;
  color: rgb(49 80 46 / var(--tw-text-opacity, 1));
}

.\\[\\&_svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-4 svg:not([class*='size-']) {
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-6 svg:not([class*='size-']) {
  width: 1.5rem;
  height: 1.5rem;
}

.\\[\\&_svg\\]\\:pointer-events-none svg {
  pointer-events: none;
}

.\\[\\&_svg\\]\\:mt-1 svg {
  margin-top: 0.25rem;
}

.\\[\\&_svg\\]\\:size-4 svg {
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:size-\\[17px\\] svg {
  width: 17px;
  height: 17px;
}

.\\[\\&_svg\\]\\:flex-\\[0_0_15px\\] svg {
  flex: 0 0 15px;
}

.\\[\\&_svg\\]\\:shrink-0 svg {
  flex-shrink: 0;
}

.\\[\\&_svg\\]\\:rounded-full svg {
  border-radius: 9999px;
}

.\\[\\&_svg\\]\\:bg-\\[\\#eef3e7\\] svg {
  --tw-bg-opacity: 1;
  background-color: rgb(238 243 231 / var(--tw-bg-opacity, 1));
}

.\\[\\&_svg\\]\\:text-\\[\\#557543\\] svg {
  --tw-text-opacity: 1;
  color: rgb(85 117 67 / var(--tw-text-opacity, 1));
}

.data-\\[state\\=open\\]\\:\\[\\&_svg\\]\\:rotate-180 svg[data-state="open"] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b tr {
  border-bottom-width: 1px;
}

[data-side=left][data-collapsible=offcanvas] .\\[\\[data-side\\=left\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-right-2 {
  right: -0.5rem;
}

[data-side=left][data-state=collapsed] .\\[\\[data-side\\=left\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-e-resize {
  cursor: e-resize;
}

[data-side=left] .\\[\\[data-side\\=left\\]_\\&\\]\\:cursor-w-resize {
  cursor: w-resize;
}

[data-side=right][data-collapsible=offcanvas] .\\[\\[data-side\\=right\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-left-2 {
  left: -0.5rem;
}

[data-side=right][data-state=collapsed] .\\[\\[data-side\\=right\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-w-resize {
  cursor: w-resize;
}

[data-side=right] .\\[\\[data-side\\=right\\]_\\&\\]\\:cursor-e-resize {
  cursor: e-resize;
}

[data-slot=card-content] .\\[\\[data-slot\\=card-content\\]_\\&\\]\\:bg-transparent {
  background-color: transparent;
}

[data-slot=popover-content] .\\[\\[data-slot\\=popover-content\\]_\\&\\]\\:bg-transparent {
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,iJAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;EAAA,iBAAc;EAAd,6BAAc;EAAd,iCAAc;EAAd,mCAAc;EAAd,2CAAc;EAAd,qCAAc;EAAd,iCAAc;EAAd,iCAAc;EAAd,uBAAc;EAAd,sCAAc;EAAd,4BAAc;EAAd,+CAAc;EAAd,8BAAc;EAAd,yCAAc;EAAd,+BAAc;EAAd,2CAAc;EAAd,2BAAc;EAAd,uCAAc;EAAd,+BAAc;EAAd,wCAAc;EAAd,iCAAc;EAAd,6CAAc;EAAd,kCAAc;EAAd,4BAAc;EAAd,uCAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,yCAAc;EAAd,gDAAc;EAAd,iDAAc;EAAd,qCAAc;EAAd,gDAAc;EAAd,uCAAc;EAAd,mCAAc;EAAA;;AAAd;EAAA,iCAAc;EAAd,iCAAc;EAAd,2BAAc;EAAd,sCAAc;EAAd,4BAAc;EAAd,+CAAc;EAAd,8BAAc;EAAd,yCAAc;EAAd,gCAAc;EAAd,2CAAc;EAAd,4BAAc;EAAd,uCAAc;EAAd,+BAAc;EAAd,8CAAc;EAAd,gCAAc;EAAd,6CAAc;EAAd,+BAAc;EAAd,4BAAc;EAAd,2BAAc;EAAd,wCAAc;EAAd,sCAAc;EAAd,sCAAc;EAAd,sCAAc;EAAd,uCAAc;EAAd,8BAAc;EAAd,yCAAc;EAAd,gDAAc;EAAd,iDAAc;EAAd,qCAAc;EAAd,gDAAc;EAAd,uCAAc;EAAd,mCAAc;AAAA;EAAd;EAAA,mCAAc;EAAd,wBAAc;;IAAd;AAAc;AACd;EAAA,sBAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,oCAAoC;;AAJpC;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,mBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA,QAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,iDAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kDAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,2GAwFA;EAxFA,yGAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,6BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,iDAwFA;EAxFA,qDAwFA;EAxFA;AAwFA;;AAxFA;EAAA,+EAwFA;EAxFA,mGAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA,8BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,gFAwFA;EAxFA,oGAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,yCAwFA;EAxFA;AAwFA;;AAxFA;EAAA,8BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,2GAwFA;EAxFA,yGAwFA;EAxFA;AAwFA;;AAxFA;EAAA,2GAwFA;EAxFA,yGAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,8BAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,2GAwFA;EAxFA,yGAwFA;EAxFA;AAwFA;;AAxFA;EAAA,2GAwFA;EAxFA,yGAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,mBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,yBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,yBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,yBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,qBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,0CAwFA;EAxFA,uDAwFA;EAxFA;AAwFA;;AAxFA;EAAA,2GAwFA;EAxFA,yGAwFA;EAxFA;AAwFA;;AAxFA;EAAA,2GAwFA;EAxFA,yGAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,qBAwFA;EAxFA,yBAwFA;EAxFA,2BAwFA;EAxFA,yBAwFA;EAxFA,0BAwFA;EAxFA,+BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA,yBAwFA;EAxFA,0BAwFA;EAxFA,wBAwFA;EAxFA,yBAwFA;EAxFA,8BAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,qBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,mBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,0EAwFA;EAxFA,8FAwFA;EAxFA;AAwFA;;AAxFA;EAAA,2GAwFA;EAxFA,yGAwFA;EAxFA;AAwFA;;AAxFA;EAAA,0BAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,kBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,qBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,gDAwFA;IAxFA,2DAwFA;IAxFA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,+BAwFA;IAxFA;EAwFA;;EAxFA;IAAA,kBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,oBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,mBAwFA;IAxFA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA,qBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,sBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,oBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,iBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,iBAwFA;IAxFA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA,oBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,uBAwFA;IAxFA,mDAwFA;IAxFA;EAwFA;;EAxFA;IAAA,uBAwFA;IAxFA,sDAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,qBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,oBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,qBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,kBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,mBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,mBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,qBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,oBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,iBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,iBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,eAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,oBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,mBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,kBAwFA;IAxFA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA,gBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,WAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,qBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,qBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,gBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,iBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,iBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,iBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,eAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,mBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,mBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,mBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,0BAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,0EAwFA;IAxFA,8FAwFA;IAxFA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,kBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,iBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,QAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,yBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,qBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA,oBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,iBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,mBAwFA;IAxFA;EAwFA;;EAxFA;IAAA,iBAwFA;IAxFA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;AAAA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,iDAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,kDAwFA;EAxFA;AAwFA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;AAAA;;AAxFA;;EAAA;IAAA;EAwFA;;EAxFA;IAAA;EAwFA;AAAA;;AAxFA;EAAA,2BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,2BAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,+BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,4BAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kDAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,qBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,mBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,gBAwFA;EAxFA,uBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,gBAwFA;EAxFA,oBAwFA;EAxFA,4BAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,sBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,eAwFA;EAxFA;AAwFA;;AAxFA;EAAA,WAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,8BAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,8BAwFA;EAxFA;AAwFA;;AAxFA;EAAA,8BAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,mBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,iBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,WAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,WAwFA;EAxFA;AAwFA;;AAxFA;EAAA,aAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,WAwFA;EAxFA;AAwFA;;AAxFA;EAAA,WAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA,kBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,oBAwFA;EAxFA;AAwFA;;AAxFA;EAAA,mBAwFA;EAxFA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA;;AAxFA;EAAA;AAwFA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@custom-variant dark (&:is(.dark *));\n\n@layer base {\n:root {\n  --radius: 0.65rem;\n  --background: oklch(1 0 0deg);\n  --foreground: oklch(0.145 0 0deg);\n  --hajj-primary: hsl(145deg 45% 35%);\n  --hajj-primary-foreground: hsl(0deg 0% 98%);\n  --hajj-secondary: hsl(145deg 35% 50%);\n  --hajj-accent: hsl(85deg 65% 60%);\n  --hajj-muted: hsl(145deg 10% 85%);\n  --card: oklch(1 0 0deg);\n  --card-foreground: oklch(0.145 0 0deg);\n  --popover: hsl(0deg 0% 100%);\n  --popover-foreground: hsl(222.2deg 47.4% 11.2%);\n  --primary: oklch(0.205 0 0deg);\n  --primary-foreground: oklch(0.985 0 0deg);\n  --secondary: oklch(0.97 0 0deg);\n  --secondary-foreground: oklch(0.205 0 0deg);\n  --muted: oklch(0.97 0 0deg);\n  --muted-foreground: oklch(0.556 0 0deg);\n  --accent: hsl(210deg 40% 96.1%);\n  --accent-foreground: oklch(0.205 0 0deg);\n  --destructive: hsl(0deg 100% 50%);\n  --destructive-foreground: hsl(210deg 40% 98%);\n  --border: oklch(1 0deg 0deg / 10%);\n  --input: hsl(216deg 34% 17%);\n  --chart-1: oklch(0.646 0.222 41.116deg);\n  --chart-5: oklch(0.769 0.188 70.08deg);\n  --sidebar: oklch(0.985 0 0deg);\n  --sidebar-foreground: oklch(0.145 0 0deg);\n  --sidebar-primary: oklch(0.488 0.243 264.376deg);\n  --sidebar-primary-foreground: oklch(0.985 0 0deg);\n  --sidebar-accent: oklch(0.269 0 0deg);\n  --sidebar-accent-foreground: oklch(0.985 0 0deg);\n  --sidebar-border: oklch(1 0 0deg / 10%);\n  --sidebar-ring: oklch(0.556 0 0deg);\n  }\n\n.dark {\n  --background: oklch(0.145 0 0deg);\n  --foreground: oklch(0.985 0 0deg);\n  --card: oklch(0.205 0 0deg);\n  --card-foreground: oklch(0.985 0 0deg);\n  --popover: hsl(0deg 0% 100%);\n  --popover-foreground: hsl(222.2deg 47.4% 11.2%);\n  --primary: oklch(0.922 0 0deg);\n  --primary-foreground: oklch(0.205 0 0deg);\n  --secondary: oklch(0.269 0 0deg);\n  --secondary-foreground: oklch(0.985 0 0deg);\n  --muted: oklch(0.269 0 0deg);\n  --muted-foreground: oklch(0.708 0 0deg);\n  --accent: hsl(210deg 40% 96.1%);\n  --accent-foreground: hsl(222.2deg 47.4% 11.2%);\n  --destructive: hsl(0deg 63% 31%);\n  --destructive-foreground: hsl(210deg 40% 98%);\n  --border: oklch(1 0 0deg / 10%);\n  --input: hsl(216deg 34% 17%);\n  --ring: oklch(0.556 0 0deg);\n  --chart-1: oklch(0.488 0.243 264.376deg);\n  --chart-2: oklch(0.696 0.17 162.48deg);\n  --chart-3: oklch(0.769 0.188 70.08deg);\n  --chart-4: oklch(0.627 0.265 303.9deg);\n  --chart-5: oklch(0.645 0.246 16.439deg);\n  --sidebar: oklch(0.205 0 0deg);\n  --sidebar-foreground: oklch(0.985 0 0deg);\n  --sidebar-primary: oklch(0.488 0.243 264.376deg);\n  --sidebar-primary-foreground: oklch(0.985 0 0deg);\n  --sidebar-accent: oklch(0.269 0 0deg);\n  --sidebar-accent-foreground: oklch(0.985 0 0deg);\n  --sidebar-border: oklch(1 0 0deg / 10%);\n  --sidebar-ring: oklch(0.556 0 0deg);\n}\n\n}\n\n@layer base {\n  body {\n    @apply bg-background text-foreground;\n\n    font-family: sans-serif;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
